<template>
  <div id="box">
    <!-- 顶部起始位置 -->
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <div id="mainBox" class="main-with-history">
      <div v-if="isPage == 'index'" class="body">
        <div class="topFilter">
          <div class="filterBar">
            <div class="filterItem filterItem--date">
              <el-date-picker
                v-model="timeVle"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              />
            </div>
            <div class="filterItem">
              <el-select
                @change="searchSelectFn"
                v-model="searchType"
                placeholder="全部状态"
                :clearable="true"
              >
                <el-option
                  v-for="(item, index) in searchData"
                  :value="item.status"
                  :key="index"
                  :label="item.name"
                />
              </el-select>
            </div>
            <div class="filterItem">
              <el-select
                @change="searchSelectFn"
                v-model="isFastType"
                placeholder="是否快速下单"
                :clearable="true"
              >
                <el-option
                  v-for="(item, index) in isFast"
                  :value="item.id"
                  :key="index"
                  :label="item.name"
                />
              </el-select>
            </div>
            <div class="filterItem">
              <el-select
                @change="priceChangeFn"
                v-model="priceType"
                placeholder="鉴别时效"
                :clearable="true"
              >
                <el-option
                  v-for="(item, index) in priceData"
                  :value="item.name"
                  :key="index"
                  :label="item.name"
                />
              </el-select>
            </div>
            <div class="filterItem">
              <el-input v-model="nameVle" placeholder="用户名称" @keyup.enter.native="searchFn" clearable />
            </div>
            <div class="filterItem">
              <el-input v-model="brandNameVle" placeholder="品牌名称" @keyup.enter.native="searchFn" clearable />
            </div>
            <div class="filterItem">
              <el-input v-model="typeNameVle" placeholder="型号名称" @keyup.enter.native="searchFn" clearable />
            </div>
            <div class="filterItem">
              <el-input v-model="searchVle" placeholder="订单号/父级订单号" @keyup.enter.native="searchFn" clearable />
            </div>
            <div class="filterItem">
              <el-input v-model="idVle" placeholder="主键ID" @keyup.enter.native="searchFn" clearable />
            </div>
            <div class="filterItem">
              <el-input v-model="logisticsVle" placeholder="寄出单号" @keyup.enter.native="searchFn" clearable />
            </div>
            <div class="filterItem">
              <el-input v-model="logisticsVle2" placeholder="寄回单号" @keyup.enter.native="searchFn" clearable />
            </div>
            <div class="filterActions">
              <el-button type="success" size="small" @click="searchFn">查询</el-button>
              <el-button size="small" @click="resetFn">重置</el-button>
              <el-button type="success" size="small" @click="excelFn">导出excel</el-button>
            </div>
          </div>
        </div>

        <!-- 主体内容 -->
        <div class="orderMain">
          <div class="table-scroll-wrap">
          <el-table
            :data="tableData"
            border
            :height="tebleHeight"
            style="width: 100%; margin-top: 10px"
            @selection-change="handleSelectionChange"
            @row-click="clickData"
          >
            <el-table-column prop="jbsx" width="140" align="center" label="鉴别时效">
              <template slot-scope="scope">
                <div v-if="scope.row.jbsx">{{ scope.row.jbsx.time }}小时</div>
              </template>
            </el-table-column>
            <el-table-column prop="jbService" width="180" align="center" label="鉴别服务">
              <template slot-scope="scope">
                <div>{{ formatJbServiceName(scope.row) }}</div>
              </template>
            </el-table-column>

            <el-table-column prop="nickName" width="140" align="center" label="用户">
              <template slot-scope="scope">
                <div v-if="scope.row.user">
                  <img
                    style="width: 40px; height: 40px"
                    @click="previewFn(scope.row.user.photo)"
                    :src="scope.row.user.photo"
                    alt=""
                    srcset=""
                  />
                  <div style="margin-top: 6px">{{ scope.row.user.nickName }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="nickName" width="200" align="center" label="图片">
              <template slot-scope="scope">
                <div
                  class="imgBox flex"
                  v-if="orderListThumb(scope.row) || (scope.row.images && (scope.row.images.img || scope.row.images.packImg))"
                >
                  <div class="imgLi" v-if="orderListThumb(scope.row)">
                    <img
                      @click="previewFn(orderListThumb(scope.row))"
                      :src="orderListThumb(scope.row)"
                      alt=""
                    />
                    <div class="text">型号</div>
                  </div>
                  <div class="imgLi" v-if="scope.row.images && scope.row.images.img">
                    <img
                      @click="previewFn(scope.row.images.img)"
                      :src="scope.row.images.img | assetUrl"
                      alt=""
                      srcset=""
                    />
                    <div class="text">产品图片</div>
                  </div>
                  <div class="imgLi" v-if="scope.row.images && scope.row.images.packImg">
                    <img
                      @click="previewFn(scope.row.images.packImg)"
                      :src="scope.row.images.packImg | assetUrl"
                      alt=""
                      srcset=""
                    />
                    <div class="text">产品包装</div>
                  </div>
                </div>
                <span v-else style="color: #909399">-</span>
              </template>
            </el-table-column>
            <el-table-column prop="batchNum" align="center" label="品牌型号和批次号">
              <template slot-scope="scope">
                <div style="text-align: left">
                  <div v-if="scope.row.brand">
                    品牌：{{ scope.row.brand.name }}
                    <span v-if="scope.row.brand.name"
                      >- {{ scope.row.brand.englishName }}</span
                    >
                  </div>
                  <div v-if="scope.row.type">
                    型号：{{ scope.row.type.name }}
                    <span v-if="scope.row.type.name"
                      >- {{ scope.row.type.englishName }}</span
                    >
                  </div>
                  <div v-if="scope.row.batchNum">批次号：{{ scope.row.batchNum }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="depict" align="center" label="备注"> </el-table-column>

            <el-table-column prop="bz" align="center" label="管理员备注">
            </el-table-column>
            <!-- <el-table-column prop="depict" align="center" label="是否寄售">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.sfjs - 0 ? "是" : "否" }}
                </div>
              </template>
            </el-table-column> -->
            <el-table-column prop="depict" align="center" label="是否快速下单">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.isFast - 0 ? "是" : "否" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="orderId" align="center" label="订单编号">
            </el-table-column>
            <!-- <el-table-column prop="price" align="center" label="价格">
            </el-table-column> -->
            <el-table-column prop="time" align="center" label="创建时间">
            </el-table-column>
            <el-table-column prop="telephone" align="center" label="状态">
              <template slot-scope="scope">
                <div :style="{ color: resolveVerificationDisplayStatus(scope.row).color }">
                  {{ resolveVerificationDisplayStatus(scope.row).title }}
                </div>

                <div v-if="scope.row.ychl">乙醇：{{ scope.row.ychl || '' }}</div>
                <div v-if="scope.row.antiForgeryCode">编号：{{ scope.row.antiForgeryCode }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="depict" align="center" label="回寄地址">
              <template slot-scope="scope">
                <div v-if="scope.row.address && scope.row.address.id">
                  <div>
                    {{ scope.row.address.name }} {{ scope.row.address.telephone }}
                  </div>

                  <div>
                    {{ getAreaString(scope.row.address) }} {{ scope.row.address.detail }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="depict" align="center" label="鉴定未通过地址">
              <template slot-scope="scope">
                <div v-if="scope.row.address2 && scope.row.address2.id">
                  <div>
                    {{ scope.row.address2.name }} {{ scope.row.address2.telephone }}
                  </div>

                  <div>
                    {{ getAreaString(scope.row.address2) }} {{ scope.row.address2.detail }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="200" prop="price" align="center" label="物流信息">
              <template slot-scope="scope">
                <div style="text-align: left">
                  <template v-if="scope.row.kdname || scope.row.kdno">
                    <!-- 新的物流（带kdname/kdno） -->
                    <div>
                      寄出物流：
                      <span>
                        {{ getCompanyTitle(scope.row.kdname) }}
                      </span>
                    </div>
                    <div>
                      寄出单号：
                      <span v-if="scope.row.kdno">{{ scope.row.kdno }}</span>
                      <span v-else>暂无</span>
                    </div>
                  </template>

                  <template v-else-if="scope.row.logistics">
                    <!-- 旧的物流 -->
                    <div>
                      寄出物流：
                      <span v-if="scope.row.logistics && scope.row.logistics.title">
                        {{ scope.row.logistics.title }}
                      </span>
                      <span v-else>暂无</span>
                    </div>
                    <div>
                      寄出单号：
                      <span v-if="scope.row.logistics && scope.row.logistics.num">
                        {{ scope.row.logistics.num }}
                      </span>
                      <span v-else>暂无</span>
                    </div>
                  </template>

                  <div>
                    寄回物流：
                    <span v-if="scope.row.hxinfo && scope.row.hxinfo.title">
                      {{ scope.row.hxinfo.title }}
                    </span>
                    <span v-else>暂无</span>
                  </div>
                  <div>
                    寄回单号：
                    <span v-if="scope.row.hxinfo && scope.row.hxinfo.num">
                      {{ scope.row.hxinfo.num }}
                    </span>
                    <span v-else>暂无</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="120" prop="price" align="center" label="鉴别结果">
              <template slot-scope="scope">
                <span
                  v-if="xwOrderJbjgResultLabel(scope.row)"
                  :style="{ color: xwOrderJbjgResultColor(scope.row), fontWeight: 'bold' }"
                >{{ xwOrderJbjgResultLabel(scope.row) }}</span>
                <span v-else style="color: #909399">-</span>
              </template>
            </el-table-column>

            <el-table-column min-width="200" align="center" label="操作">
              <template slot-scope="scope">
                <p class="btnLi" style="margin-bottom: 10px">
                  <el-button
                    type="success"
                    size="small"
                    v-if="scope.row.status < 4"
                    @click="editFn(scope.row)"
                    >编辑</el-button
                  >
                </p>

                <p class="btnLi" style="margin-top: 10px">
                  <el-button
                    type="success"
                    v-if="scope.row.status == 1"
                    size="small"
                    @click="updateFn(scope.row, '开始鉴别')"
                    >开始鉴别</el-button
                  >
                </p>

                <!-- <p class="btnLi" style="margin-top: 10px">
                  <el-button type="success" size="small" @click="updateFn(scope.row, 2)"
                    >测试修改状态</el-button
                  >
                </p> -->

                <p class="btnLi" style="margin-top: 10px">
                  <el-button
                    type="success"
                    size="small"
                    @click="identifyFn(scope.row)"
                    v-if="scope.row.status == 2"
                    >平台鉴别</el-button
                  >
                </p>
<!--                <p class="btnLi" style="margin-top: 10px">-->
<!--                  <el-button-->
<!--                    type="primary"-->
<!--                    size="small"-->
<!--                    @click="identifyFreshFn(scope.row)"-->
<!--                    v-if="scope.row.status == 2"-->
<!--                    >全新鉴别</el-button-->
<!--                  >-->
<!--                </p>-->

                <!-- <el-button
                  type="success"
                  size="small"
                  @click="onDrawQrcode(scope.row)"
                  v-if="scope.row.status === 3"
                >预览打印</el-button
                > -->

                <el-button
                  type="primary"
                  size="small"
                  plain
                  @click="openReportPreview(scope.row)"
                  v-if="canPreviewXwOrderReport(scope.row)"
                >查看报告</el-button
                >

                <el-button
                  type="warning"
                  size="small"
                  plain
                  style="margin-left: 8px"
                  @click="openOrderVerifyEdit(scope.row)"
                  v-if="canEditXwOrderInspection(scope.row)"
                >修改鉴别</el-button
                >

                <el-button
                  type="primary"
                  size="small"
                  @click="normalPrint(scope.row)"
                  v-if="scope.row.status === 3"
                >鉴别报告打印</el-button
                >
<!--                <el-button-->
<!--                  type="primary"-->
<!--                  size="small"-->
<!--                  plain-->
<!--                  @click="freshReportPrint(scope.row)"-->
<!--                  v-if="scope.row.status === 3"-->
<!--                >全新报告打印</el-button-->
<!--                >-->

                <!-- <p style="margin-top: 10px">
                  <el-button
                    type="success"
                    size="small"
                    @click="generateReportFn(scope.row)"
                    >生成报告</el-button
                  >
                </p> -->

                <p style="margin-top: 10px"></p>

                <el-button
                  type="success"
                  v-if="scope.row.status == 3"
                  size="small"
                  @click="updateFn(scope.row, '寄回')"
                  >手动寄回</el-button
                >

                <!-- <p style="margin-top: 10px"></p>

                <el-button
                  type="success"
                  v-if="scope.row.status == 3"
                  size="small"
                  @click="kdReservationFn(scope.row)"
                  >顺丰寄回</el-button
                > -->

                <p style="margin-top: 10px">
                  <el-button
                    type="warning"
                    v-if="canRefundOrder(scope.row)"
                    size="small"
                    @click="refundFn(scope.row)"
                    >退款</el-button
                  >
                </p>

                <p style="margin-top: 10px">
                  <el-button
                    type="info"
                    plain
                    v-if="canCloseOrder(scope.row)"
                    size="small"
                    @click="closeOrderFn(scope.row)"
                    >取消订单</el-button
                  >
                </p>

                <p style="margin-top: 10px">
                  <el-button
                    type="danger"
                    size="small"
                    v-if="canRollbackVerificationOrderStatus(scope.row.status)"
                    @click="rollbackStatus(scope.row)"
                    >回滚状态</el-button
                  >
                </p>

                <p style="margin-top: 10px"></p>
                <el-button
                  type="success"
                  v-if="scope.row.status == 4 || scope.row.status == 3"
                  size="small"
                  @click="updateFn(scope.row, '上传报告')"
                  >上传报告</el-button
                >

                <!-- <el-button type="info"  size="small" @click="delFn(scope.row)">删除</el-button> -->
              </template>
            </el-table-column>
          </el-table>
          </div>

          <list-pagination
            :total="tableTotal"
            :current-page.sync="currentPage"
            :page-size.sync="pageSize"
            @page-change="changePage"
            @size-change="handlePageSizeChange"
          />
        </div>
        <!-- 主体内容 -->
      </div>
    </div>

    <!-- 发货 -->
    <div class="excellent_box" v-if="excellenShow == 1">
      <div class="excellent_main">
        <div class="excellent_top">
          出具报告
          <i class="el-icon-close" @click.stop="closeFn"></i>
        </div>

        <div class="excellent_content">
          <div class="excellent_li flex" style="justify-content: center">
            <div style="width: 100px; height: 100px">
              <uploadFile @getImg="getImgFn" :image="reportImg"></uploadFile>
            </div>
          </div>

          <div class="excellent_btn flex">
            <el-button type="success" size="small" @click.stop="reportFn">提交</el-button>
            <el-button type="info" size="small" @click.stop="closeFn">取消</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 物流-->
    <div class="logistics_box" v-if="excellenShow == 2">
      <div class="excellent_main">
        <div class="excellent_top">
          寄回
          <i class="el-icon-close" @click.stop="closeFn"></i>
        </div>

        <div class="excellent_content">
          <div class="excellent_li flex">
            <span>物流公司：</span>
            <div style="width: 290px">
              <el-select v-model="com" placeholder="请选择物流公司">
                <el-option
                  v-for="item in companyData"
                  :key="item.code"
                  :label="item.title"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="excellent_li flex">
            <span>物流单号：</span>
            <div style="width: 290px">
              <el-input
                size="medium"
                v-model="num"
                placeholder="请填写物流单号"
              ></el-input>
            </div>
          </div>

          <div class="excellent_btn flex">
            <el-button type="success" size="small" @click.stop="logisticsFn"
              >提交</el-button
            >
            <el-button type="info" size="small" @click.stop="closeFn">取消</el-button>
          </div>
        </div>
      </div>
    </div>

    <!--编辑 -->
    <popupBox title="编辑" v-if="isEdit" width="580">
      <div class="popupMain">
        <div class="popupLi">
          <div class="popupLi_title">类型：</div>

          <div class="popupLi_content flex">
            <el-radio v-model="editType" :label="0">分装</el-radio>
            <el-radio v-model="editType" :label="1">不分装</el-radio>
          </div>
        </div>

        <div class="popupLi" v-show="editType === 1">
          <div class="popupLi_title">规格：</div>

          <div class="popupLi_content" style="width: 300px">
            <el-select v-model="specificationsVle" placeholder="请选择规格">
              <el-option
                v-for="item in capacityArr"
                :key="getCapacityOptionValue(item)"
                :label="item.name"
                :value="getCapacityOptionValue(item)"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="popupLi">
          <div class="popupLi_title">批次号：</div>

          <div class="popupLi_content" style="width: 300px">
            <el-input v-model="dataList.batchNum" placeholder="请输入内容"></el-input>
          </div>
        </div>

        <div class="popupLi popupLi--stacked" v-if="editType">
          <div class="popupLi_title">实物图片：</div>

          <div class="popupLi_content popupLi_content--full">
            <orderRealPictureUpload v-model="realImgs" :max="8" :columns="4" />
          </div>
        </div>
      </div>

      <div class="popupBtn flex">
        <el-button type="success" size="small" @click="confirmEditFn">确认</el-button>
        <el-button type="info" size="small" @click="isEdit = false">取消</el-button>
      </div>
    </popupBox>
    <!-- 编辑 -->

    <!--平台鉴别 -->
    <popupBox title="平台鉴别" v-if="isIdentify" width="650">
      <div class="popupMain">
        <div class="popupLi">
          <div class="popupLi_title">平台鉴别：</div>

          <div class="popupLi_content flex">
            <el-radio v-model="ptjbVle" :label="0">需要鉴别</el-radio>
            <el-radio v-model="ptjbVle" :label="1">不符退回</el-radio>
          </div>
        </div>

        <template v-if="!ptjbVle">
          <div class="popupLi">
            <div class="popupLi_title">标准图谱：</div>

            <div class="popupLi_content flex" style="width: 300px">
              <div style="width: 200px; height: 30px">
                <uploadFile @getImg="editChartFn1" :isSlot="true">
                  <el-button type="success" size="small">更改无坐标图谱</el-button>
                </uploadFile>
              </div>

              <div style="width: 200px; height: 30px">
                <uploadFile @getImg="editChartFn2" :isSlot="true">
                  <el-button type="success" size="small">更改有坐标图谱</el-button>
                </uploadFile>
              </div>
            </div>
          </div>

          <div class="popupLi">
            <div class="popupLi_title">鉴别图谱：</div>

            <div class="popupLi_content flex spectrum-jbtp-identify-wrap">
              <div class="spectrum-jbtp-mode">
                <el-radio-group v-model="identifyChartUploadMode" size="small">
                  <el-radio-button label="image">上传图片</el-radio-button>
                  <el-radio-button label="txt">TXT 生成谱图</el-radio-button>
                </el-radio-group>
              </div>
              <div v-show="identifyChartUploadMode === 'image'" class="spectrum-jbtp-upload-drag">
                <el-upload
                  class="upload-demo"
                  drag
                  :show-file-list="false"
                  :action="$api.api.uploadImg"
                  :on-success="chartImgFn"
                >
                  <div v-if="identifyList.jbtp" class="spectrum-jbtp-upload-filled">
                    <i class="el-icon-picture-outline"></i>
                    <div class="el-upload__text">已上传鉴别图谱，点击或拖拽可<em>更换</em></div>
                  </div>

                  <div v-if="!identifyList.jbtp">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  </div>
                </el-upload>
              </div>
              <div v-show="identifyChartUploadMode === 'txt'" class="spectrum-jbtp-txt-actions">
                <el-button
                  type="primary"
                  size="small"
                  plain
                  :loading="identifyTxtGenerating"
                  @click="triggerIdentifySpectrumTxtPick"
                >选择 TXT 并生成谱图</el-button>
                <input
                  ref="identifySpectrumTxtInput"
                  type="file"
                  accept=".txt,text/plain"
                  class="spectrum-jbtp-txt-input-hidden"
                  @change="onIdentifySpectrumTxtSelected"
                />
              </div>
              <div v-if="identifyList.jbtp" class="spectrum-jbtp-current-preview">
                <div class="spectrum-jbtp-preview-label">当前鉴别图谱</div>
                <div class="spectrum-jbtp-preview-box">
                  <img :src="identifyList.jbtp" class="spectrum-jbtp-preview-img" alt="鉴别图谱" />
                </div>
              </div>
            </div>
          </div>

          <div class="popupLi">
            <div class="popupLi_title">乙醇含量：</div>

            <div class="popupLi_content" style="width: 360px">
              <el-input v-model="identifyList.ychl" placeholder="请输入"></el-input>
            </div>
          </div>

          <div class="popupLi" v-if="freshIdentifyFlow">
            <div class="popupLi_title">接受样品时间：</div>
            <div class="popupLi_content" style="width: 360px">
              <el-date-picker
                v-model="identifyList.sampleReceivedAt"
                type="datetime"
                placeholder="选择接受样品时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                clearable
              />
            </div>
          </div>
        </template>
      </div>

      <div class="popupBtn flex">
        <el-button type="success" v-if="!ptjbVle" size="small" @click="confirmChartFn"
          >提交预览</el-button
        >

        <el-button type="success" v-if="ptjbVle" size="small" @click="confirmChartFn2"
          >提交</el-button
        >
        <el-button type="info" size="small" @click="closeIdentifyMain"> 取消 </el-button>
      </div>
    </popupBox>
    <!-- 平台鉴别 -->

    <!--  平台鉴别预览-->
    <popupBox title="预览" v-if="isIdentifyPreview" width="850">
      <div class="popupMain">
        <div class="popupLi">
          <div class="popupLi_title">标准图谱(有坐标)：</div>

          <div class="popupLi_content identify-preview-img-wrap">
            <img class="identify-preview-img" :src="identifyList.atlas2" alt="" />
          </div>
        </div>

        <div class="popupLi">
          <div class="popupLi_title">标准图谱(无坐标)：</div>

          <div class="popupLi_content identify-preview-img-wrap">
            <img class="identify-preview-img" :src="identifyList.atlas1" alt="" />
          </div>
        </div>

        <div class="popupLi">
          <div class="popupLi_title">鉴别图谱：</div>

          <div class="popupLi_content identify-preview-img-wrap">
            <img class="identify-preview-img" :src="identifyList.jbtp" alt="" />
          </div>
        </div>

        <div class="popupLi" style="margin: 20px auto">
          <div class="popupLi_title">乙醇对比：</div>

          <div class="popupLi_content flex">
            <div>{{ identifyList.bzyc }}（标准乙醇）</div>
            <div style="margin-left: 60px">{{ identifyList.ychl }}（乙醇含量）</div>
          </div>
        </div>

        <div class="popupLi" v-if="freshIdentifyFlow">
          <div class="popupLi_title">接受样品时间：</div>
          <div class="popupLi_content">{{ identifyList.sampleReceivedAt || "—" }}</div>
        </div>

        <div class="popupLi">
          <div class="popupLi_title">鉴别结果：</div>

          <div class="popupLi_content flex" style="justify-content: space-between">
            <div class="flex">
              <el-radio v-model="jbjgVle" v-removeAriaHidden :label="1">鉴别为真</el-radio>
              <el-radio v-model="jbjgVle" v-removeAriaHidden :label="0">鉴别为假</el-radio>
            </div>

            <div class="flex" style="margin-right: 20px">
              <span style="margin-right: 10px">防伪码编号：</span>
              <el-input v-model="antiForgeryCode" style="width: 180px" placeholder="请输入防伪码编号"></el-input>
            </div>
          </div>
        </div>
      </div>

      <div class="popupBtn flex">
        <el-button type="success" size="small" @click="confirmIdentifyFn">提交</el-button>
        <el-button type="info" size="small" @click="cancelIdentifyPreview"> 取消 </el-button>
      </div>
    </popupBox>
    <!--  平台鉴别预览-->

    <!-- 生成报告 -->

    <div class="reportBox" v-if="isReport">
      <div id="capture" class="captureBox">
        <!-- 水印 -->
        <div class="watermark">
          <!-- <div
            class="watermarkLi"
            v-for="(item, index) in watermarkArr"
            :style="{ top: item.y, left: item.x }"
          >
            香味研究所
          </div> -->
          <img class="watermarkBg" :src="initImgOjb.watermarkBg" alt="" srcset="" />
        </div>
        <!-- 水印 -->

        <!-- 背景图片 -->
        <template v-if="reportList.sffz - 0">
          <!-- 不分装 -->
          <img
            :src="initImgOjb.captureBg1"
            v-if="reportList.jbjg - 0"
            alt="背景"
            class="captureBg"
          />
          <img
            :src="initImgOjb.captureBg2"
            v-if="!(reportList.jbjg - 0)"
            alt="背景"
            class="captureBg"
          />
        </template>

        <template v-if="!(reportList.sffz - 0)">
          <!-- 分装 -->
          <img
            :src="initImgOjb.captureBg3"
            v-if="reportList.jbjg - 0"
            alt="背景"
            class="captureBg"
          />
          <img
            :src="initImgOjb.captureBg4"
            v-if="!(reportList.jbjg - 0)"
            alt="背景"
            class="captureBg"
          />
        </template>

        <!-- 背景图片 -->

        <div class="captureMain">
          <div class="captureTop">
            <!-- 日期 -->
            <div class="time">{{ reportTime }}</div>

            <!-- 编号-->
            <div class="code">{{ identifyCode || "" }}</div>
          </div>

          <!-- 商品信息 -->
          <div class="captureGoods flex">
            <div class="captureGoods_li goodsMain">
              <div class="goodsLi" style="text-align: left; word-break: break-word;">
                {{ reportList.brand.name }} {{ reportList.brand.englishName }}
              </div>
              <div class="goodsLi" style="text-align: left; word-break: break-word; white-space: normal; overflow-wrap: break-word; width: 580px; padding-right: 20px; position: absolute; left: 23px; line-height: 30px; min-height: 30px; margin-top: 20px;">
                {{ reportList.type.name }} {{ reportList.type.englishName }}
              </div>
              <div class="goodsLi flex">
                <div class="goodsLi_num">
                  <template v-if="reportList.sffz - 0">{{
                    specificationStr || ""
                  }}</template>
                  <template v-if="!(reportList.sffz - 0)"> 分装</template>
                </div>
                <div class="goodsLi_num" v-if="reportList.sffz - 0">
                  {{ reportList.batchNum ? reportList.batchNum : "客户未提供" }}
                </div>
                <div class="goodsLi_num" v-if="!(reportList.sffz - 0)">分装无批号</div>
              </div>
            </div>

            <div class="captureGoods_li realMain">
              <template v-if="reportList.sffz - 0">
                <div class="realLi_img">
                  <img :src="actualImg.img1" alt="" srcset="" />
                </div>
                <div class="realLi_img">
                  <img :src="actualImg.img2" alt="" srcset="" />
                </div>
                <div class="realLi_img">
                  <img :src="actualImg.img3" alt="" srcset="" />
                </div>
                <div class="realLi_img">
                  <img :src="actualImg.img4" alt="" srcset="" />
                </div>
              </template>
              <!-- 实物 -->

              <!-- 无实物 -->
              <!-- <template v-if="!(reportList.sffz - 0)">
                <div class="noRealTxt">客户以分装形式提供样品，无实物图</div>
              </template> -->
              <!-- 无实物 -->
            </div>
          </div>

          <!--图谱 -->
          <div class="chartMain">
            <div class="chartMain_li">
              <img class="chartMain_li_img" :src="chartImg.img2" alt="" srcset="" />

              <img class="chartMain_li_img" :src="chartImg.img3" alt="" srcset="" />
            </div>
            <div class="chartMain_li chartMainEnd">
              <div class="chartMain_overlap">
                <img class="overlap_img" :src="chartImg.img1" alt="" srcset="" />
                <img class="overlap_img" :src="chartImg.img3" alt="" srcset="" />
              </div>

              <!-- <div class="chartMain_text">
                经专业色谱对比得到结果，指纹图谱相识度<span
                  :style="{ color: reportList.jbjg - 0 ? '#18961d' : '#f22626' }"
                  class="chartMainEnd_color"
                  >大于95%</span
                >，该商品内容物符合正品工艺要求，<span
                  :style="{ color: reportList.jbjg - 0 ? '#18961d' : '#f22626' }"
                  class="chartMainEnd_color"
                  >鉴别通过</span
                >
              </div> -->
            </div>
          </div>
          <!--图谱 -->
        </div>
      </div>
    </div>
    <!-- 生成报告 -->

    <!--  预约快递-->
    <popupBox title="预约快递" v-if="isReservation" width="600">
      <div class="popupMain">
        <div class="popupLi">
          <div class="popupLi_title" style="width: 120px">预约时间：</div>

          <div class="popupLi_content">
            <el-date-picker
              v-model="reservationTime"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="选择日期时间"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="popupLi">
          <div class="popupLi_title" style="width: 120px">托寄物数量：</div>

          <div class="popupLi_content">
            <el-input
              v-model="reservationNum"
              type="number"
              placeholder="请输入"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="popupBtn flex">
        <el-button type="success" size="small" @click="addisReservationFn"
          >提交</el-button
        >
        <el-button type="info" size="small" @click="closeReservationFn"> 取消 </el-button>
      </div>
    </popupBox>
    <!--  平台鉴别预览-->

    <div class="textareaFrame" v-if="isTextarea" @click="bgClickFn">
      <div class="textareaMain" @click.stop="">
        <div class="title">备注</div>
        <!-- <div class="text">{{text}}</div> -->

        <textarea
          :placeholder="placeholder"
          v-model="textareaVle"
          placeholder-style="color:#ccc;"
        />

        <div class="textareaBtnBox">
          <div class="textareaBtnLi" @click.stop="cancelRemarksFn">取消</div>
          <div
            class="textareaBtnLi"
            @click.stop="confirmRemarksFn"
            style="color: #2d76fd"
          >
            确定
          </div>
        </div>
      </div>
    </div>

        <!-- 添加预览弹窗 -->
        <el-dialog
        class="preview-dialog"
        title="打印预览"
        :visible.sync="previewDialogVisible"
        width="500px"
        :before-close="handleClosePreview"
    >
        <div class="preview-container">
            <div v-for="(image, index) in previewImages" :key="index" class="preview-item">
                <img :src="image" alt="预览图片" />
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClosePreview">关 闭</el-button>
            <el-button type="primary" @click="onPrintImageData">打 印</el-button>
        </span>
    </el-dialog>

    <!-- 打印状态提示 -->
    <el-dialog
        title="打印状态"
        :visible.sync="printDialogVisible"
        width="400px"
        :before-close="handleClosePrintDialog"
    >
        <div style="text-align: center; padding: 20px;">
            {{ printResultMessage }}
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClosePrintDialog">关 闭</el-button>
        </span>
    </el-dialog>

    <el-dialog
      title="修改鉴别结果"
      :visible.sync="orderVerifyVisible"
      width="1000px"
      :close-on-click-modal="false"
      custom-class="inspection-verify-dialog"
      @closed="onOrderVerifyClosed"
    >
      <OrderVerify
        v-if="orderVerifyJobId"
        :job-id="orderVerifyJobId"
        :initial-result-appearance="orderVerifyInitialAppearance"
        :edit-mode="orderVerifyEditMode"
        @close="orderVerifyVisible = false"
        @success="onOrderVerifySuccess"
      />
    </el-dialog>

    <el-dialog
      title="鉴别报告预览"
      :visible.sync="reportPreviewVisible"
      width="420px"
      top="4vh"
      custom-class="inspection-report-preview-dialog"
      :close-on-click-modal="false"
      @closed="onReportPreviewClosed"
    >
      <div class="report-preview-dialog-body">
        <JbReportPreview
          v-if="reportPreviewOrderId"
          :key="reportPreviewOrderId"
          :order-id="reportPreviewOrderId"
          :order-type="reportPreviewOrderType"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { delTips, returnTime, isJSON } from "@/util/utils";
import { runXwOrderRefund, runXwOrderClose, canCloseXwOrder, canRefundXwOrder } from "@/util/xwOrderRefund";
import {
  fetchOrderCapacityOptions,
  capacityItemToSpecification,
  specificationToCapacityItem,
  getCapacitySelectValue,
  resolveOrderBrandId,
} from "@/util/specCapacityCompat";
import expressInfo from "@/util/expressInfo";
import elUpload from "@/components/elUpload";
import popupBox from "@/components/popupBox";
import orderRealPictureUpload from "@/components/orderRealPictureUpload";
import {
  parseRealPictureUrls,
  realPictureUrlsToSlots,
  realPicturePathForReportLoad,
} from "@/util/orderRealPicture";
import {
  canRollbackVerificationOrderStatus,
  resolvePreviousVerificationOrderStatus,
} from "@/util/orderStatusRollback";
import html2canvas from "html2canvas";
import { DTPWeb, LPA_PrintActions } from "dtpweb";
import logoBase64 from './logoBase64.js';
import jsonOperator from '@/components/json_demo.js';
import {
  SPECTRUM_TXT_MAX_POINTS,
  parseSpectrumTxt,
  downsampleSpectrumPairs,
  renderTxtSpectrumChartToDataUrlAsync,
} from "@/util/spectrumTxtChart";
import JbReportPreview from "@/components/jbReport/JbReportPreview.vue";
import OrderVerify from "@/pages/inspectionJob/orderVerify.vue";
import { orderTypeThumb } from "@/util/reportAssetUrl.js";
import {
  VERIFICATION_ORDER_STATUS,
  VERIFICATION_STATUS_FILTERS,
  resolveRowDisplayStatus,
  resolveStatusConfig,
} from "@/util/xwOrderStatus";
import {
  canPreviewXwOrderReport,
  canEditXwOrderInspection,
  xwOrderJbjgResultLabel,
  xwOrderJbjgResultColor,
} from "@/util/xwOrderReport.js";

export default {
  components: {
    uploadFile: elUpload,
    popupBox,
    orderRealPictureUpload,
    JbReportPreview,
    OrderVerify,
  },

  data() {
    return {
      isPage: "index",

      tebleHeight: 500,

      imageData: "",

      dataList: {},
      tempList: {
        img: "",
      },

      antiForgeryCode: "", // 防伪码编号

      // 编辑弹框
      isEdit: false,
      editType: "",

      realImgs: [],

      //弹框
      excellenShow: 0,

      // 时间
      timeVle: [],

      // 物流
      logisticsShow: 0,
      companyData: expressInfo.arr,
      companyObj: expressInfo.obj,
      com: "shunfeng",
      num: "",
      phoneVle: "",

      // 历史记录
      historyArr: ["订单管理"],

      //  搜索
      idVle: "",
      searchVle: "",
      nameVle: "", //用户名称
      notesVle: "", //备注名称
      brandNameVle: "", //品牌名称
      typeNameVle: "", //(型号名称)

      //快递单号
      logisticsVle: "",
      logisticsVle2: "",

      // 订单状态（与小程序鉴别列表对齐）
      orderStatus: VERIFICATION_ORDER_STATUS,

      // 搜索类型
      searchType: -2,
      searchData: VERIFICATION_STATUS_FILTERS,

      // 鉴别时效
      priceType: "",
      priceData: [
        {
          name: "96小时--49元",
          id: 1,
        },
        {
          name: "24小时--129元",
          id: 2,
        }
        // ,{
        //   name: "12小时--129元",
        //   id: 3,
        // },
      ],

      pickerOptions: {
        selectableRange: "08:00:00 - 20:00:00",
        disabledDate(time) {
          // 选择今天以及今天之后的日期
          return time.getTime() < Date.now() - 8.64e7; // 如果没有后面的-8.64e7就是不可以选择
          // 选择今天以及今天之前的日期
          // return time.getTime() > Date.now() - 8.64e7// 如果没有后面的-8.64e7就是不可以选择今天的
        },
      },

      // 出具报告
      reportImg: "",

      //规格
      specificationsInfo: [],
      specificationsVle: "",
      capacityList: "",
      capacityArr: [],

      // 品牌
      brandId: -1,
      brandData: [],

      // 型号
      typeId: -1,
      typeData: [],

      //平台鉴别
      isIdentify: false,
      ptjbVle: 0,
      jbjgVle: 0,
      /** 鉴别图谱：image 上传；txt 由仪器 TXT 生成 PNG */
      identifyChartUploadMode: "image",
      identifyTxtGenerating: false,
      identifyList: {
        jbjg: 0,
        ptjb: 0,
      },

      // 鉴别预览
      isIdentifyPreview: false,
      /** 为 true 表示从「全新鉴别」进入，仅该流程传 sampleReceivedAt / reportIssuedAt */
      freshIdentifyFlow: false,

      // 报告
      isReport: false,
      identifyCode: "",
      specificationStr: "",
      reportList: {},
      chartImg: {}, //图谱
      actualImg: {}, //实物
      reportTime: "", //鉴别时间
      watermarkArr: [], //水印
      imgLoading: "", //图片合成

      // 初始化照片
      initImgOjb: {
        watermarkBg: "",
        captureBg: "",
        identifyImg1: "",
        identifyImg2: "",
        identifyImg3: "",
        identifyImg4: "",
      },

      // 快递预约
      reservationList: {},
      isReservation: false,
      reservationTime: "",
      reservationNum: 1,

      // 基础设置
      setList: {},

      // 备注
      remarksList: "",
      isTextarea: false,
      textareaVle: "",

      // 数据信息
      tableData: [],
      pageSize: 50,
      currentPage: 1,
      tableTotal: 0,

      isFastType: "",
      isFast: [
        {
          name: "快速下单",
          id: 1,
        },
        {
          name: "详细下单",
          id: 0,
        }
      ],
      antiForgeryCode: "", // 防伪码编号
      printers: [{ name: "", value: {} }],
      currPrinter: { name: "" },
      api: undefined,
      currOrientation: 0,
      currAction: LPA_PrintActions.PrevBase64,
      previewDialogVisible: false,  // 控制预览弹窗的显示
      previewImages: [],
      imageTimestamp: new Date().getTime(), // 添加时间戳
      reportPreviewVisible: false,
      reportPreviewOrderId: null,
      reportPreviewOrderType: null,

      orderVerifyVisible: false,
      orderVerifyJobId: null,
      orderVerifyEditMode: false,
      orderVerifyInitialAppearance: null,

      // 打印相关数据
      printSocket: null,
      printMessage: "",
      printResultMessage: null,
      printIndex: 0,
      printNum: 0, // 已打印数量
      totalNum: 0, // 总打印数量
      darkness: 15, // 打印机打印黑度
      printSpeed: 4, // 打印机打印速度
      printError: false,
      printJson: { // 打印机和标签的公共参数
        Printer: {
          printername: 'ZMIN X1i',
          printerinterface: 'USB',
          printerdpi: '300',
          printSpeed: '4',
          printDarkness: '15'
        },
        LabelFormat: {
          labelwidth: '60',    // 减小标签宽度
          labelheight: '15',   // 减小标签高度
          labelrowgap: '3'     // 设置行距为0，避免多打印
        },
        LabelObjectList: [],
        Operate: 'print'
      },
      currentPrintRow: null, // 当前打印的行数据
      /** true：全新报告打印（标签数字与二维码均按 id） */
      printQrFreshReport: false,
      printDialogVisible: false // 打印状态对话框显示状态
    };
  },
  created() {
    this.recalcTableHeight();
    window.addEventListener("resize", this.recalcTableHeight);
    // this.selcompanyFn(); //查询物流公司
    // this.selBrandFn(); //品牌
    // this.selTypeFn(); //型号
    this.initImgFn(); //查询图片
  },
  mounted() {
    this.selListFn(1);
    this.addwatermark();
    // this.selsetFn(); //查询
    DTPWeb.checkServer({
      // jsonMode: false,
      downloadUrl: "https://weida.dothantech.com/beta/assets/dtpweb/index.html",
      callback: (api, server) => {
        this.api = api;
        console.log(`---- ---- check server ---- ----`);
        console.log(server);
        if (api) {
          this.updatePrinterList();
        } else {
          this.printers[0].name = "未检测到打印插件";
        }
      },
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.recalcTableHeight);
    // 关闭打印WebSocket连接
    if (this.printSocket) {
      this.printSocket.close();
    }
  },
  methods: {
    recalcTableHeight() {
      this.tebleHeight = Math.max(300, window.innerHeight - 350);
    },

    onDrawQrcode(data, callback) {
      // 整体页面尺寸
      const pageWidth = 55;
      const pageHeight = 35;

      // 右侧竖排区域宽度
      const rightTextAreaWidth = 6; // 右侧6mm
      // 中间内容区域宽度
      const contentAreaWidth = pageWidth - rightTextAreaWidth; // 32mm

      this.api.startPrintJob({
        width: pageWidth,
        height: pageHeight,
        orientation: this.currOrientation,
        jobName: this.getJobName(),
        printer: this.currPrinter,
        action: this.getJobAction(),
        callback: (success) => {
          if (!success) return;

          // 1. 打印"香味研究所"
          const xiangweiText = '香味研究所';
          const xiangweiFontHeight = 4; // 4mm
          const xiangweiWordCount = xiangweiText.length; // 5
          const xiangweiTextHeight = xiangweiFontHeight * xiangweiWordCount + 2; // 22mm
          const xiangweiTextWidth = xiangweiFontHeight + 2; // 6mm
          const xiangweiRightOffset = -1; // 向右偏移1.5mm
          const xiangweiUpOffset = 4;     // 向上偏移1mm
          let xiangweiY = (pageHeight - xiangweiTextHeight) / 2 - xiangweiUpOffset;
          if (xiangweiY < 0) xiangweiY = 0; // 保证y不为负数，防止顶部裁切
          const xiangweiX = pageWidth - xiangweiTextWidth + xiangweiRightOffset;

          this.api.drawText({
            text: xiangweiText,
            x: xiangweiX,
            y: xiangweiY - 1,
            width: xiangweiTextWidth,
            height: xiangweiTextHeight,
            fontHeight: xiangweiFontHeight,
            fontStyle: 0,
            fontName: '黑体',
            orientation: 90,
            horizontalAlignment: 1,
            verticalAlignment: 1,
            autoReturn: 1,
          });

          // 2. 打印"撕毁无效"
          const sihuiText = '效无毁撕';
          const sihuiFontHeight = 4; // 4mm
          const sihuiCharWidth = sihuiFontHeight + 1;
          const sihuiBaseX = 15 + 4; // 二维码宽度imgW=15，右侧1mm开始排字
          let sihuiY = (pageHeight - sihuiFontHeight) / 2 - 6;
          const sihuiTextWidth = sihuiText.length * sihuiCharWidth; // 4个字的总宽度
          const sihuiTextHeight = sihuiFontHeight + 2;              // 单字高度

          for (let i = 0; i < sihuiText.length; i++) {
            this.api.drawText({
              text: sihuiText[i],
              x: sihuiBaseX + i * sihuiCharWidth,
              y: sihuiY,
              width: sihuiCharWidth,
              height: sihuiTextHeight,
              fontHeight: sihuiFontHeight,
              fontStyle: 0,
              fontName: '黑体',
              orientation: 90,
              horizontalAlignment: 1,
              verticalAlignment: 1,
              autoReturn: 0,
            });
          }

          // 3. 打印logo
          const logoBase64Data = logoBase64; // base64 数据变量
          const logoWidth = sihuiTextWidth;    // 宽度与4字总宽一致
          const logoHeight = sihuiTextHeight;  // 高度与单字一致
          const logoX = sihuiBaseX + sihuiTextWidth + 1-6; // 文字右侧1mm
          const logoY = sihuiY;                          // 与文字对齐
          const logoThreshold = 256;                     // 灰度
          const logoOrientation = 90;                    // 旋转90度

          this.api.drawImageD && this.api.drawImageD({
            data: logoBase64Data,
            x: logoX,
            y: logoY,
            width: logoWidth,
            height: logoHeight,
            threshold: logoThreshold,
            orientation: logoOrientation
          });



          const qrcodeText = data.authenticate;
          const qrcodeImgW = 16;
          const qrcodeImgH = 16;
          const qrcodeX = 2 - 2; // 往左移动1mm
          const qrcodeY = (pageHeight - qrcodeImgW) / 2 - 5; // 往上移动1mm
          const qrcodeThreshold = 192;
          const qrcodeOrientation = 90;

          this.api.draw2DQRCode({
            text: qrcodeText,
            x: qrcodeX,
            y: qrcodeY,
            width: qrcodeImgW,
            height: qrcodeImgH,
            threshold: qrcodeThreshold,
            orientation: qrcodeOrientation
          });

          const numberText = String(data.orderId).slice(-6); // 订单号后六位
          const numberFontHeight = 2; // 字体高度最小
          const numberTextLength = numberText.length;
          const numberTextWidth = numberFontHeight + 1; // 竖排单字宽度
          const numberTextHeight = qrcodeImgH; // 区域高度与二维码一致
          const numberToQrcodeGap = 0.5; // 与二维码右侧间隔0.5mm
          const numberX = qrcodeX + qrcodeImgW + numberToQrcodeGap; // 二维码右侧
          const numberY = qrcodeY; // 与二维码垂直对齐

          this.api.drawText({
            text: numberText,
            x: numberX,
            y: numberY,
            width: numberTextWidth,
            height: numberTextHeight,
            fontHeight: numberFontHeight,
            fontStyle: 0,
            fontName: '黑体',
            orientation: 90, // 竖排
            horizontalAlignment: 1, // 区域内居中
            verticalAlignment: 1,
            autoReturn: 1 // 按字换行，竖排更清晰
          });


          // 6. 提交打印任务
          return this.api.commitJob((res) => {
            this.previewJobs(res);
            callback && callback(true);
          });
        },
      });
    },
    /**
     * 获取当前任务的图片信息；
     */
    previewJobs(res) {
        if (!res) return;

        this.previewImages = []; // 清空预览图片

        if (res.printData) {
            this.printData = res.printData;
            console.log(`---- printData:`);
            console.log(res.printData);
        }
        if (res.previewData) {
            this.previewPages(res.previewData);
        }

        // 显示预览弹窗
        this.previewDialogVisible = true;
    },

    // 修改添加预览图片的方法
    previewPages(pages) {
        if (pages && pages.length > 0) {
            this.previewImages = pages; // 直接存储预览图片数据
        }
    },

    // 关闭预览弹窗
    handleClosePreview() {
        this.previewDialogVisible = false;
        this.previewImages = [];
    },

    getJobName() {
      if ((this.currAction & LPA_PrintActions.PrevBase64) !== 0) {
        // 该名称的打印任务不参与打印，仅用于返回白色底色的预览图片
        return "#!#Preview#!#";
      } else if ((this.currAction & LPA_PrintActions.Transparent) != 0) {
        // 该名称的打印任务不参与打印，进用于返回透明底色的预览图片
        return "#!#Transparent#!#";
      } else {
        // 打印任务名称，随便挑，只要不是"#!#"开头的名称都可以。
        return "jobName";
      }
    },
    getJobAction() {
      return this.currAction;
    },
    updatePrinterList() {
      if (!this.api) return;
      //
      const api = this.api;
      //
      api.getPrinters((values) => {
        // 清空旧打印机列表
        this.printers.splice(0);
        //
        if (values && values.length > 0) {          // 修改这行，去掉可选链操作符
          for (const item of values) {
            const title = api.isLocalPrinter(item)
              ? item.deviceName || item.name
              : `${item.deviceName || item.name}@${item.ip}`;
            this.printers.push({
              name: title,
              value: item,
            });
          }
        } else {
          this.printers.push({ name: "未检测到打印机", value: "" });
        }
        //
        this.currPrinter = this.printers[0].value;
        //
        this.onPrinterChanged();
      });
    },
    onPrinterChanged() {
      console.log(`---- onPrinterChanged:`);
      console.log(this.currPrinter);
      if (this.currPrinter) {
        if (this.currPrinter.deviceDPI) {
          this.printerDPI = this.currPrinter.deviceDPI;
        }
        if (this.currPrinter.deviceWidth) {
          this.printerWidth = this.currPrinter.deviceWidth;
        }
      }
    },
    async onPrintImageData() {
      if (this.previewImages && this.previewImages.length > 0) {
        try {
          for (const imgSrc of this.previewImages) {
            const result = await this.api.printImage({
              data: imgSrc,
              printerName: this.currPrinter && this.currPrinter.name ? this.currPrinter.name : '',
              copies: 1,
              orientation: this.currOrientation,
            });
            console.log("打印结果",result)
            if (!result) {
              this.$message.error(result.message || '打印失败');
              return;
            }
          }
          this.$message.success('打印成功');
        } catch (error) {
          this.$message.error(error.message || '打印过程中发生错误');
          return;
        }
      }
      this.handleClosePreview(); // 打印后关闭预览窗口
    },
    // 查看详情
    clickData: function (row, column, cell, event) {
      if (column.property == "bz") {
        let list = row;
        this.remarksList = list;
        this.textareaVle = list.bz;
        this.isTextarea = 1;
        return;
      }
    },

    bgClickFn() {
      this.isTextarea = false;
    },
    cancelRemarksFn() {
      this.isTextarea = false;
    },
    confirmRemarksFn() {
      this.isTextarea = false;
      let vle = this.textareaVle;
      let list = this.remarksList;
      if (!vle) {
        this.$message.error("请输入内容");
        return;
      }

      this.$https(
        this.$api.api.upOrder,
        {
          id: list.id,
          bz: vle,
        },
        "POST"
      ).then((res) => {
        if (res.data.code == 200) {
          this.selListFn(this.currentPage);
          this.isEdit = false;
        }
      });
    },

    // 搜索
    searchFn: function (res) {
      this.currentPage = 1;
      this.selListFn(1);
    },

    resetFn() {
      this.timeVle = [];
      this.searchType = -2;
      this.isFastType = "";
      this.priceType = "";
      this.nameVle = "";
      this.notesVle = "";
      this.brandNameVle = "";
      this.typeNameVle = "";
      this.searchVle = "";
      this.idVle = "";
      this.logisticsVle = "";
      this.logisticsVle2 = "";
      this.brandId = -1;
      this.typeId = -1;
      this.currentPage = 1;
      this.selListFn(1);
    },

    // 查询
    selsetFn: function () {
      var urls = this.$api.api.selSet;
      var data = {
        page: 1,
        size: 1,
      };
      this.$https(urls, data, "POST").then((res) => {
        if (res.data.code == 200 && res.data.data.length > 0) {
          let data = res.data.data[0];
          this.setList = data;
        }
      });
    },

    // 快递预约
    kdReservationFn(list) {
      this.reservationTime = "";
      this.reservationNum = 1;
      this.isReservation = true;
      this.reservationList = list;
    },

    // 确认预约
    addisReservationFn() {
      let list = this.reservationList;
      let time = this.reservationTime;
      let setList = this.setList;
      let reservationNum = this.reservationNum;

      if (!time) {
        this.$message.error("请选择预约时间");
        return;
      }
      if (!reservationNum) {
        this.$message.error("请输入托寄物数量");
        return;
      }

      let sendAddres = "";
      // 判断真假
      if (list.jbjg - 0) {
        sendAddres = list.address;
      } else {
        sendAddres = list.address2;
      }

      let addressStr =
        sendAddres.area[0] + sendAddres.area[1] + sendAddres.area[2] + sendAddres.detail;

      let price = this.countFn(sendAddres.area[1], reservationNum);

      let obj = {
        address: "浙江省杭州市余杭区余杭塘路2301号海智中心3幢", //寄件人详细地址
        contact: "蔡绍杰", //寄件人姓名
        mobile: "18358141523", //寄件人手机号码

        address2: addressStr, //收件人详细地址
        contact2: sendAddres.name, //收件人姓名
        mobile2: sendAddres.telephone, //收件人号码
        count: reservationNum, //托寄物数量
        amount: price, //金额

        orderid: list.orderId,
        fatherorderid: list.fatherOrderId,
        sendStartTm: returnTime(time, "-", "s"),
      };

      this.$https(this.$api.api.addReservation, obj, "POST").then((res) => {
        if (res.data.data) {
          let kd = res.data.data;
          let list = {
            code: "shunfeng",
            phone: sendAddres.telephone,
            title: "顺丰速运",
            num: kd,
          };

          let obj = {
            id: list.id,
            status: 4,
            hxinfo: JSON.stringify(list),
          };
          this.updateOrderFn(obj);
          this.isReservation = false;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    // 计算金额
    countFn(province, num) {
      // 快递金额（快递服务费:6瓶以下，江浙沪12元，徽14元，省外18元;超过6瓶，每3瓶增加二分之一的价格）

      let price = 18;

      if (
        province.indexOf("江苏") != -1 ||
        province.indexOf("浙江") != -1 ||
        province.indexOf("上海") != -1
      ) {
        price = 12;
      }

      if (province.indexOf("安徽") != -1) {
        price = 14;
      }

      let goodsLength = num;

      if (goodsLength > 6) {
        let endNum = goodsLength - 6;
        let multiple = Math.ceil(endNum / 3);
        let half = price / 2;
        price = price + multiple * half;
      }

      return price;
    },

    // 关闭预约弹框
    closeReservationFn() {
      this.isReservation = false;
    },

    // 初始化图片
    initImgFn() {
      let path = "https://hzshixiang.site";
      let watermarkBg = "/jxupload/picture/XSJD17442662505962177.png"; //水印
      let captureBg1 = "/jxupload/picture/XSJD17447286625835607.png"; //裁剪背景图1
      let captureBg2 = "/jxupload/picture/XSJD17447287344936101.png"; //裁剪背景图2
      let captureBg3 = "/jxupload/picture/XSJD17447287574254616.png"; //裁剪背景图3
      let captureBg4 = "/jxupload/picture/XSJD17447287798571682.png"; //裁剪背景图4
      // let identifyImg1 = "/jxupload/picture/XSJD17442710706852854.png"; //鉴别通过
      // let identifyImg2 = "/jxupload/picture/XSJD17442710898623095.png"; //鉴别不通过
      // let identifyImg3 = "/jxupload/picture/XSJD17442712577473452.png"; //鉴别通过（分装）
      // let identifyImg4 = "/jxupload/picture/XSJD17442712720986027.png"; //鉴别不通过（不分装）

      // 转base64

      let img1 = this.getImgBase64Fn(watermarkBg);

      let captureImg1 = this.getImgBase64Fn(captureBg1);
      let captureImg2 = this.getImgBase64Fn(captureBg2);
      let captureImg3 = this.getImgBase64Fn(captureBg3);
      let captureImg4 = this.getImgBase64Fn(captureBg4);

      // let img3 = this.getImgBase64Fn(identifyImg1);
      // let img4 = this.getImgBase64Fn(identifyImg2);
      // let img5 = this.getImgBase64Fn(identifyImg3);
      // let img6 = this.getImgBase64Fn(identifyImg4);

      Promise.all([img1, captureImg1, captureImg2, captureImg3, captureImg4]).then(
        (res) => {
          let obj = {
            watermarkBg: res[0],
            captureBg1: res[1],
            captureBg2: res[2],
            captureBg3: res[3],
            captureBg4: res[4],
          };
          this.initImgOjb = obj;
        }
      );
    },

    // 获取base64图片
    getImgBase64Fn(path) {
      return new Promise((r, c) => {
        const myImage = new Image();
        myImage.crossOrigin = "Anonymous"; // 告诉浏览器图片可能跨域，但仍尝试发送CORS请求
        myImage.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.width = myImage.width;
          canvas.height = myImage.height;
          ctx.drawImage(myImage, 0, 0);
          const dataURL = canvas.toDataURL("image/jpg");
          r(dataURL);
        };

        myImage.onerror = () => {
          r(false);
        };

        myImage.src = path;
      });
    },

    // 加水印
    addwatermark() {
      const stepX = 200;
      const stepY = 200;
      let arr = [];
      for (let x = 0; x < 1000; x += stepX) {
        for (let y = 0; y < 1413; y += stepY) {
          arr.push({ x: x + stepX / 2 + "px", y: y + stepY / 2 + "px" });
        }
      }

      this.watermarkArr = arr;
    },

    takeScreenshot() {
      const captureElement = document.getElementById("capture"); // 获取截图元素
      html2canvas(captureElement)
        .then(async (canvas) => {
          // 将生成的 Canvas 转为图片数据
          let imgFile = canvas.toDataURL("image/jpg");
          this.imageData = imgFile;
          console.log("截图成功");

          let imgList = await this.uploadImgFnV2(imgFile);
          if (imgList && imgList.path) {
            let list = this.reportList;
            let obj = {
              id: list.id,
              status: 3,
              authenticate: imgList.path,
              reportIssuedAt: this.reportIssuedAtForOrderApi(),
              // authenticate2: imgList.path,
            };
            if (this.identifyCode) {
              obj.identifyNo = this.identifyCode;
            }
            this.updateOrderFn(obj).then((res) => {
              if (res && res.data && res.data.code === 200) {
                this.freshIdentifyFlow = false;
              }
            });

            // 发送短信通知
            this.sendReportNotify(list.orderId);

            this.isIdentify = false;
            this.isIdentifyPreview = false;
          }

          this.imgLoading.close();
          this.isReport = false;
        })
        .catch((error) => {
          this.imgLoading.close();
          this.isReport = false;
          console.error("截图失败:", error);
        });
    },

    // 发送报告通知短信
    sendReportNotify(orderId) {
      // 完全异步调用，不等待结果
      this.$https(this.$api.api.sendReportNotify, {
        orderId: orderId
      }, 'POST').then((res) => {
        if (res.data.code === 200) {
          console.log('短信通知发送成功');
        } else {
          console.error('短信通知发送失败:', res.data.msg);
        }
      }).catch((error) => {
        console.error('短信通知发送异常:', error);
      });
    },

    // 上传图片
    uploadImgFn: function (base64) {
      return new Promise((r, c) => {
        let no = new Date(new Date()).valueOf() + "_" + Math.round(Math.random() * 1000);
        let imgFile = this.dataURLtoFile(base64, no + ".jpg");
        let form = new FormData();
        form.append("file", imgFile);
        form.append("no", no);
        let config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };
        this.$https(this.$api.api.uploadImg, form, "POST").then((res) => {
          r(res.data.data);
        });
      });
    },

    uploadImgFnV2: function (base64) {
      console.log("上传图片V2");
      return new Promise((r, c) => {
        // 构建文件名
        const now = new Date();
        const orderLastSix = this.reportList.orderId ? this.reportList.orderId.slice(-6) : '';
        const dateStr = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}`;

        // 从reportList获取品牌和型号信息
        const brandName = this.reportList.brand ? this.reportList.brand.name : '';
        const modelName = this.reportList.type ? this.reportList.type.name : '';
        const antiForgeryCode = this.reportList.antiForgeryCode || '';

        // 组合文件名，过滤掉空值并用下划线连接，然后移除特殊字符
        const fileName = [dateStr, antiForgeryCode, brandName, modelName, orderLastSix]
          .filter(item => item && item.trim()) // 过滤掉空值和纯空格的值
          .join('-')
          .replace(/[\\/:*?"<>|]/g, '');
        console.log(fileName, "文件名")
        let imgFile = this.dataURLtoFile(base64, fileName + ".jpg");
        let form = new FormData();
        form.append("file", imgFile);
        form.append("customFileName", fileName);
        let config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };
        this.$https(this.$api.api.uploadImgV2, form, "POST").then((res) => {
          r(res.data.data);
        });
      });
    },

    // 把base64 转换成文件对象
    dataURLtoFile: function (base64Str, fileName) {
      var arr = base64Str.split(","),
        mime = arr[0].match(/:(.*?);/)[1], //base64解析出来的图片类型
        bstr = atob(arr[1]), //对base64串进行操作，去掉url头，并转换为byte atob为window内置方法
        len = bstr.length,
        ab = new ArrayBuffer(len), //将ASCII码小于0的转换为大于0
        u8arr = new Uint8Array(ab); //
      while (len--) {
        u8arr[len] = bstr.charCodeAt(len);
      }
      // 创建新的 File 对象实例[utf-8内容，文件名称或者路径，[可选参数，type：文件中的内容mime类型]]
      return new File([u8arr], fileName, {
        type: mime,
      });
    },

    // 生成鉴别号
    identifyCodeFn() {
      return new Promise((r, c) => {
        this.$https(this.$api.api.identifyCode, {}, "GET").then((res) => {
          if (res.data.code == 200) {
            r(res.data.data);
            console.log("生成鉴别号");
          }
        });
      });
    },

    // 生成报告
    async generateReportFn(list) {
      this.imgLoading = this.$loading({
        lock: true,
        text: "报告生成中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      this.reportList = list;

      //规格
      let specification = isJSON(list.specification)
        ? JSON.parse(list.specification)
        : "";

      if (specification && specification.ml) {
        this.specificationStr = specification.ml + "" + "ml";
      } else {
        this.specificationStr = "无规格";
      }

      let time = this.currentTimeFn();
      this.reportTime = time;
      let code = await this.identifyCodeFn();
      this.identifyCode = code;
      let img1 = (list.atlas1 || "").replace("https://hzshixiang.site", ""); //无坐标
      let img2 = (list.atlas2 || "").replace("https://hzshixiang.site", ""); //有坐标
      let img3 = (list.jbtp || "").replace("https://hzshixiang.site", ""); //结果
      let chartImg1 = this.getImgBase64Fn(img1); //图谱1
      let chartImg2 = this.getImgBase64Fn(img2); //图谱2
      let chartImg3 = this.getImgBase64Fn(img3); //分析结果
      console.log("数据内容", list);

      // 判断是否是封装去请求图片
      if (!(list.sffz - 0)) {
        //分装无实物图片
        Promise.all([chartImg1, chartImg2, chartImg3]).then((res) => {
          this.chartImg = {
            img1: res[0],
            img2: res[1],
            img3: res[2],
          };

          this.isReport = true;
          setTimeout(() => {
            this.takeScreenshot();
          }, 1000);
        });
      } else {
        // 不封装有实物图片
        const realImgObj = realPictureUrlsToSlots(list.realpicture);

        if (realImgObj.img1 || realImgObj.img2 || realImgObj.img3 || realImgObj.img4) {
          let actualImg1 = this.getImgBase64Fn(realPicturePathForReportLoad(realImgObj.img1));
          let actualImg2 = this.getImgBase64Fn(realPicturePathForReportLoad(realImgObj.img2));
          let actualImg3 = this.getImgBase64Fn(realPicturePathForReportLoad(realImgObj.img3));
          let actualImg4 = this.getImgBase64Fn(realPicturePathForReportLoad(realImgObj.img4));

          //分装无实物图片
          Promise.all([
            chartImg1,
            chartImg2,
            chartImg3,
            actualImg1,
            actualImg2,
            actualImg3,
            actualImg4,
          ]).then((res) => {
            this.chartImg = {
              img1: res[0],
              img2: res[1],
              img3: res[2],
            };

            // 实物
            this.actualImg = {
              img1: res[3],
              img2: res[4],
              img3: res[5],
              img4: res[6],
            };

            this.isReport = true;
            setTimeout(() => {
              this.takeScreenshot();
            }, 1000);
          });
        } else {
          //无实物图片
          Promise.all([chartImg1, chartImg2, chartImg3]).then((res) => {
            this.chartImg = {
              img1: res[0],
              img2: res[1],
              img3: res[2],
            };

            this.isReport = true;
            setTimeout(() => {
              this.takeScreenshot();
            }, 1000);
          });
        }
      }
    },

    currentTimeFn() {
      // 获取当前日期
      const today = new Date();

      // 获取年份
      const year = today.getFullYear();

      // 获取月份 (注意，月份从0开始，0表示1月，11表示12月)
      const month = today.getMonth() + 1; // 加1因为月份是从0开始的

      // 获取日期
      const day = today.getDate();

      // 输出当前年月日

      return `${year}-${month}-${day}`;
    },

    // 出具报告
    reportFn() {
      if (!this.reportImg) {
        this.$message.error("请上传鉴别报告图");
        return;
      }

      let status = this.dataList.status;

      let obj = {
        id: this.dataList.id,
        status: status,
        authenticate: this.reportImg,
        reportIssuedAt: this.reportIssuedAtForOrderApi(),
      };
      if (this.identifyCode) {
        obj.identifyNo = this.identifyCode;
      }
      this.updateOrderFn(obj);
    },

    // 出具报告
    logisticsFn() {
      if (!this.com) {
        this.$message.error("请选择物流公司");
        return;
      }

      if (!this.num) {
        this.$message.error("请输入物流单号");
        return;
      }

      let index = this.companyData.findIndex((v, i) => {
        return v.code == this.com;
      });
      let company = this.companyData[index];

      let tempList = this.dataList;

      let phone = "";
      if (tempList.jbjg - 0) {
        phone = tempList.addres ? tempList.address.telephone : "";
      } else {
        phone = tempList.address ? tempList.address2.telephone : "";
      }

      let list = {
        code: company.code,
        phone: phone,
        title: company.title,
        num: this.num,
      };

      let obj = {
        id: tempList.id,
        status: 4,
        hxinfo: JSON.stringify(list),
      };

      this.updateOrderFn(obj);
    },

    // 下拉变化
    searchSelectFn() {
      this.selListFn(1);
    },

    // 出具报告
    getImgFn(res) {
      this.reportImg = res;
    },

    // 获取物流公司标题，容错空值和缺失key
    getCompanyTitle(code) {
      if (!code || !this.companyObj) return "暂无";
      const item = this.companyObj[code];
      return item && item.title ? item.title : "暂无";
    },

    /** 鉴别服务展示：仅类型（不含金额）；历史无 jb_service 默认「液体鉴别」 */
    formatJbServiceName(row) {
      const DEFAULT_LABEL = "液体鉴别";
      if (!row) return DEFAULT_LABEL;
      let parsed = null;
      const s = row.jbService;
      if (s && typeof s === "object") {
        parsed = s;
      } else {
        const raw = row.jb_service != null ? row.jb_service : row.jbService;
        if (typeof raw === "string" && raw.trim() && isJSON(raw)) {
          try {
            parsed = JSON.parse(raw);
          } catch (e) {
            parsed = null;
          }
        }
      }
      return this.normalizeJbServiceDisplayLabel(parsed) || DEFAULT_LABEL;
    },
    normalizeJbServiceDisplayLabel(service) {
      if (!service || typeof service !== "object") return "";
      const id = Number(service.id);
      if (id === 1) return "外观+液体鉴别";
      if (id === 3) return "分装液体鉴别";
      if (id === 2) return "外观鉴别";
      let name = service.name != null ? String(service.name).trim() : "";
      if (!name) return "";
      name = name.replace(/--\s*\d+(\.\d+)?\s*元?$/i, "").trim();
      if (/外观\s*\+\s*液体|液体\s*\+\s*外观|外观\+液体/.test(name)) {
        return "外观+液体鉴别";
      }
      if (/分装\s*液体/.test(name)) {
        return "分装液体鉴别";
      }
      if (/外观/.test(name) && !/液体/.test(name)) {
        return "外观鉴别";
      }
      if (/液体/.test(name)) {
        return "外观+液体鉴别";
      }
      return name;
    },

    resolveVerificationDisplayStatus(row) {
      return resolveRowDisplayStatus(row, this.orderStatus);
    },

    // 获取状态配置，兼容数字/字符串/空值
    getOrderStatus(status) {
      return resolveStatusConfig(status, this.orderStatus);
    },

    //编辑
    confirmEditFn() {
      let realImgs = this.realImgs;
      let editType = this.editType; // 是否分装

      // 规格
      let specificationsVle = this.specificationsVle;
      let capacityArr = this.capacityArr;

      if (editType) {
        // if (!realImg.img1) {
        //   this.$message.error("请上传实物");
        //   return;
        // }
        // if (!realImg.img2) {
        //   this.$message.error("请上传实物");
        //   return;
        // }
        // if (!realImg.img3) {
        //   this.$message.error("请上传实物");
        //   return;
        // }
        // if (!realImg.img4) {
        //   this.$message.error("请上传实物");
        //   return;
        // }
      }
      let list = this.dataList;
      let obj = {
        batchNum: list.batchNum,
        sffz: editType,
        realpicture: JSON.stringify(realImgs),
        id: list.id,
      };

      let i = capacityArr.findIndex((v) => {
        return getCapacitySelectValue(v) == specificationsVle;
      });

      if (i != -1) {
        const spec = capacityItemToSpecification(capacityArr[i]);
        if (spec) obj.specification = JSON.stringify(spec);
      }

      this.$https(this.$api.api.upOrder, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.selListFn(this.currentPage);
          this.isEdit = false;
        }
      });
    },

    // 取消编辑
    closePasswordFn() {
      this.isEdit = false;
    },

    /** 后端可能返回 sampleReceivedAt 为毫秒/秒时间戳，需转为 el-date-picker 的 value-format 字符串 */
    tsMsToDatetimeString(ms) {
      const d = new Date(ms);
      if (Number.isNaN(d.getTime())) return "";
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    normalizeSampleReceivedAtForPicker(row) {
      if (!row || row.sampleReceivedAt == null || row.sampleReceivedAt === "") return;
      const v = row.sampleReceivedAt;
      if (typeof v === "string") {
        const t = v.trim();
        if (!/^\d+$/.test(t)) return;
        let ms = Number(t);
        if (ms < 1e12) ms *= 1000;
        const s = this.tsMsToDatetimeString(ms);
        if (s) row.sampleReceivedAt = s;
        return;
      }
      if (typeof v === "number") {
        let ms = v;
        if (ms < 1e12) ms *= 1000;
        const s = this.tsMsToDatetimeString(ms);
        if (s) row.sampleReceivedAt = s;
      }
    },

    /** POST order/update 中 Date：Jackson 默认认 ISO-8601，勿直接传 "yyyy-MM-dd HH:mm:ss" */
    formatDateTimeForOrderApi(val) {
      if (val == null || val === "") return null;
      if (typeof val === "number") {
        const ms = val < 1e12 ? val * 1000 : val;
        const d = new Date(ms);
        return Number.isNaN(d.getTime()) ? null : d.toISOString();
      }
      const s = String(val).trim();
      if (!s) return null;
      if (s.includes("T")) return s;
      if (/^\d+$/.test(s)) {
        let ms = Number(s);
        if (ms < 1e12) ms *= 1000;
        const d = new Date(ms);
        return Number.isNaN(d.getTime()) ? null : d.toISOString();
      }
      if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}(:\d{2})?$/.test(s)) {
        return s.replace(" ", "T");
      }
      return s;
    },
    reportIssuedAtForOrderApi() {
      return new Date().toISOString();
    },

    // 平台鉴别（不传 sampleReceivedAt；报告出具时在 takeScreenshot/reportFn 写入 reportIssuedAt）
    identifyFn: function (list) {
      this.freshIdentifyFlow = false;
      let temp = JSON.parse(JSON.stringify(list));
      this.ptjbVle = temp.ptjb - 0 || 0;
      this.jbjgVle = temp.jbjg - 0 || 0;
      this.identifyList = temp;

      this.identifyChartUploadMode = "image";
      this.identifyTxtGenerating = false;
      this.isIdentify = true;
    },

    // 全新鉴别：同平台鉴别流程，仅本入口传 sampleReceivedAt、报告出具时传 reportIssuedAt
    identifyFreshFn(list) {
      this.freshIdentifyFlow = true;
      let temp = JSON.parse(JSON.stringify(list));
      this.normalizeSampleReceivedAtForPicker(temp);
      this.ptjbVle = temp.ptjb - 0 || 0;
      this.jbjgVle = temp.jbjg - 0 || 0;
      this.identifyList = temp;
      this.identifyChartUploadMode = "image";
      this.identifyTxtGenerating = false;
      this.isIdentify = true;
    },

    closeIdentifyMain() {
      this.isIdentify = false;
      this.freshIdentifyFlow = false;
    },

    /** 预览弹窗「取消」：关闭预览；全新鉴别流程下放弃本次操作 */
    cancelIdentifyPreview() {
      this.isIdentifyPreview = false;
      this.freshIdentifyFlow = false;
      this.antiForgeryCode = "";
    },

    // 谱图1
    editChartFn1(res) {
      this.$set(this.identifyList, "atlas1", res);
    },

    // 谱图2
    editChartFn2(res) {
      this.$set(this.identifyList, "atlas2", res);
    },

    // 识别图片
    chartImgFn(res) {
      if (res.data && res.data.path) {
        let path = res.data.path;
        this.$set(this.identifyList, "jbtp", path);
      }
    },

    triggerIdentifySpectrumTxtPick() {
      const el = this.$refs.identifySpectrumTxtInput;
      if (el) el.click();
    },

    onIdentifySpectrumTxtSelected(ev) {
      const input = ev && ev.target;
      if (!input || !input.files || !input.files[0]) return;
      const file = input.files[0];
      input.value = "";
      const name = (file.name || "").toLowerCase();
      if (!name.endsWith(".txt")) {
        this.$message.warning("请选择 .txt 文本文件");
        return;
      }
      this.identifyTxtGenerating = true;
      const reader = new FileReader();
      const vm = this;
      reader.onload = () => {
        try {
          const text = String(reader.result || "");
          const rawPts = parseSpectrumTxt(text);
          if (rawPts.length < 2) {
            vm.identifyTxtGenerating = false;
            vm.$message.error("未能从 TXT 中解析出有效数据点，请检查是否为两列数值格式");
            return;
          }
          const pts = downsampleSpectrumPairs(rawPts, SPECTRUM_TXT_MAX_POINTS);
          renderTxtSpectrumChartToDataUrlAsync(pts)
            .then((dataUrl) => vm.uploadJbtpChartFromDataUrl(dataUrl))
            .then(() => {
              vm.$message.success("谱图已生成并上传");
            })
            .catch((e) => {
              vm.$message.error((e && e.message) || "谱图生成或上传失败");
            })
            .finally(() => {
              vm.identifyTxtGenerating = false;
            });
        } catch (err) {
          vm.identifyTxtGenerating = false;
          vm.$message.error((err && err.message) || "生成谱图失败");
        }
      };
      reader.onerror = () => {
        this.identifyTxtGenerating = false;
        this.$message.error("读取文件失败");
      };
      reader.readAsText(file, "UTF-8");
    },

    uploadJbtpChartFromDataUrl(dataUrl) {
      return new Promise((resolve, reject) => {
        const no = new Date().valueOf() + "_" + Math.round(Math.random() * 1000);
        let imgFile;
        try {
          imgFile = this.dataURLtoFile(dataUrl, no + ".png");
        } catch (e) {
          reject(new Error("图片数据转换失败"));
          return;
        }
        const form = new FormData();
        form.append("file", imgFile);
        form.append("no", no);
        this.$https(this.$api.api.uploadImg, form, "POST")
          .then((res) => {
            const inner = res && res.data;
            const payload = inner && inner.data;
            const p = (payload && payload.path) || (inner && inner.path) || "";
            if (p) {
              this.$set(this.identifyList, "jbtp", p);
              resolve(p);
            } else {
              reject(new Error((inner && inner.msg) || "上传失败"));
            }
          })
          .catch(() => {
            reject(new Error("网络错误"));
          });
      });
    },

    // 平台识别
    confirmChartFn() {
      let list = this.identifyList;

      if (!list.jbtp) {
        this.$message.error("请上传鉴别图谱");
        return;
      }

      if (!list.ychl) {
        this.$message.error("请输入乙醇含量");
        return;
      }

      let obj = {
        atlas1: list.atlas1,
        atlas2: list.atlas2,
        jbtp: list.jbtp,
        ychl: list.ychl,
        id: list.id,
        ptjb: this.ptjbVle || 0,
      };
      if (this.freshIdentifyFlow) {
        obj.sampleReceivedAt = this.formatDateTimeForOrderApi(list.sampleReceivedAt);
      }

      this.$https(this.$api.api.upOrder, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.selListFn(this.currentPage);
          this.antiForgeryCode = ""; // 清空防伪码编号
          this.isIdentifyPreview = true;
        }
      });
    },

    // 提交不预览
    confirmChartFn2() {
      let list = this.identifyList;
      let obj = {
        ptjb: this.ptjbVle || 0,
        id: list.id,
        status: 4,
      };

      this.$https(this.$api.api.upOrder, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.selListFn(this.currentPage);
          this.freshIdentifyFlow = false;
          this.isIdentify = false;
          this.isIdentifyPreview = false;
          this.antiForgeryCode = ""; // 清空防伪码编号
        }
      });
    },

    // 提交
    confirmIdentifyFn() {
      let list = this.identifyList;
      list.ptjb = this.ptjbVle || 0;
      list.jbjg = this.jbjgVle || 0;

      let obj = {
        atlas1: list.atlas1,
        atlas2: list.atlas2,
        jbtp: list.jbtp,
        ychl: list.ychl,
        ptjb: this.ptjbVle || 0,
        jbjg: this.jbjgVle || 0,
        antiForgeryCode: this.antiForgeryCode,
        id: list.id,
        // status: 2,
      };
      if (this.freshIdentifyFlow) {
        obj.sampleReceivedAt = this.formatDateTimeForOrderApi(list.sampleReceivedAt);
      }

      this.$https(this.$api.api.upOrder, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.selListFn(this.currentPage);
          // 将antiForgeryCode添加到list对象中，以便在生成报告时使用
          list.antiForgeryCode = this.antiForgeryCode;
          this.antiForgeryCode = ""; // 清空防伪码编号
          this.generateReportFn(list);
        }
      });
    },

    // 查询
    selcompanyFn: function (page) {
      return;
      var obj = {
        page: 1,
        size: 1000,
      };

      this.$https(this.$api.api.selLogistics, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.companyData = res.data.data;
        }
      });
    },

    // 查询品牌
    selBrandFn: function (page) {
      var obj = {
        page: 1,
        size: 1000,
      };

      this.$https(this.$api.api.selBrand, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          let arr = res.data.data;
          arr.unshift({ id: -1, name: "全部品牌" });
          this.brandData = arr;
        }
      });
    },

    // 查询品牌型号
    selTypeFn: function (page) {
      var obj = {
        page: 1,
        size: 1000,
      };

      this.$https(this.$api.api.selModel, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          let arr = res.data.data;
          arr.unshift({ id: -1, name: "全部型号" });
          this.typeData = arr;
        }
      });
    },

    // 更新图片时间戳
    updateImageTimestamp() {
      this.imageTimestamp = new Date().getTime();
    },
    // 获取带时间戳的图片URL
    getImageUrl(url) {
      return url ? url + '?t=' + this.imageTimestamp : '';
    },
    orderListThumb(row) {
      return orderTypeThumb(row);
    },
    canPreviewXwOrderReport,
    canEditXwOrderInspection,
    xwOrderJbjgResultLabel,
    xwOrderJbjgResultColor,
    openReportPreview(row) {
      if (!canPreviewXwOrderReport(row)) {
        this.$message.warning("当前订单暂无可预览的报告");
        return;
      }
      this.reportPreviewOrderId = row.id;
      this.reportPreviewOrderType = null;
      this.reportPreviewVisible = true;
    },
    onReportPreviewClosed() {
      this.reportPreviewOrderId = null;
      this.reportPreviewOrderType = null;
    },
    openOrderVerifyEdit(row) {
      if (!canEditXwOrderInspection(row)) {
        this.$message.warning("当前订单不可修改鉴别结果");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "加载鉴别作业...",
        spinner: "el-icon-loading",
      });
      this.$https(
        this.$api.api.getInspectionJobList,
        {
          orderId: row.id,
          orderType: 2,
          page: 1,
          size: 1,
        },
        "POST"
      )
        .then((res) => {
          loading.close();
          if (!res.data || res.data.code !== 200) {
            this.$message.error((res.data && res.data.msg) || "查询鉴别作业失败");
            return;
          }
          const records =
            (res.data.data && res.data.data.records) || [];
          const job = records[0];
          if (!job || !job.id) {
            this.$message.warning("未找到鉴别作业");
            return;
          }
          const jobStatus = Number(job.status);
          if (Number.isNaN(jobStatus) || jobStatus < 3) {
            this.$message.warning("当前鉴别作业状态不可修改");
            return;
          }
          this.orderVerifyJobId = job.id;
          this.orderVerifyEditMode = true;
          const app =
            row.inspectionResultAppearance != null
              ? row.inspectionResultAppearance
              : job.resultAppearance;
          this.orderVerifyInitialAppearance =
            app != null ? Number(app) : null;
          this.orderVerifyVisible = true;
        })
        .catch(() => {
          loading.close();
        });
    },
    onOrderVerifyClosed() {
      this.orderVerifyJobId = null;
      this.orderVerifyEditMode = false;
      this.orderVerifyInitialAppearance = null;
    },
    onOrderVerifySuccess() {
      this.orderVerifyVisible = false;
      this.onOrderVerifyClosed();
      this.selListFn(this.currentPage);
    },
    // 图片预览
    previewFn(path) {
      window.open(this.getImageUrl(path));
    },

    priceChangeFn() {
      this.selListFn(this.currentPage);
    },

    getCapacityOptionValue(item) {
      return getCapacitySelectValue(item);
    },

    loadEditCapacityOptions(list) {
      const brandId = resolveOrderBrandId(list, list.type);
      return fetchOrderCapacityOptions(
        this.$https,
        this.$api.api.brandSpecEnabledOptions,
        brandId,
        list.specification
      ).then((arr) => {
        this.capacityArr = arr;
        let specification = isJSON(list.specification)
          ? JSON.parse(list.specification)
          : list.specification;
        const selected = specificationToCapacityItem(specification);
        if (selected) {
          this.specificationsVle = getCapacitySelectValue(selected);
        } else {
          this.specificationsVle = "";
        }
        return arr;
      });
    },

    // 编辑
    editFn: function (list) {
      this.dataList = list;

      this.editType = list.sffz - 0 || 0;
      this.specificationsVle = "";
      this.capacityArr = [];
      this.isEdit = true;

      this.realImgs = parseRealPictureUrls(list.realpicture);

      this.loadEditCapacityOptions(list);
    },

    // 更新订单状态
    updateFn(list, status) {
      this.dataList = list;
      if (status == "寄回") {
        this.com = "shunfeng";
        this.num = "";
        this.excellenShow = 2;
        return;
      } else if (status == "上传报告") {
        this.excellenShow = 1;
      } else if (status == "开始鉴别") {
        let obj = {
          id: list.id,
        };
        this.startIdentify(obj);

      }  else {
        let obj = {
          id: list.id,
          status: status,
        };
        this.updateOrderFn(obj);
      }
    },

    // 更改订单数据
    updateOrderFn(obj) {
      return this.$https(this.$api.api.upOrder, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.excellenShow = 0;
          this.updateImageTimestamp(); // 更新时间戳
          this.selListFn(this.currentPage);
        }
        return res;
      });
    },

    // 开始鉴别
    startIdentify(obj) {
      return this.$https(this.$api.api.startIdentify, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.excellenShow = 0;
          this.updateImageTimestamp(); // 更新时间戳
          this.selListFn(this.currentPage);
        }
        return res;
      });
    },

    // 退款：仅退款 / 关单退款
    refundFn(list) {
      runXwOrderRefund(this, this.$api.api.xwOrderAdminRefund, list).then(() => {
        this.selListFn(this.currentPage);
      }).catch(() => {});
    },

    canCloseOrder(row) {
      return canCloseXwOrder(row);
    },

    canRefundOrder(row) {
      return canRefundXwOrder(row);
    },

    closeOrderFn(list) {
      runXwOrderClose(this, this.$api.api.xwOrderAdminClose, list).then(() => {
        this.selListFn(this.currentPage);
      }).catch(() => {});
    },

    // 订单选中
    handleSelectionChange: function (res) {
      this.selectAll = res;
    },

    // 批量下单
    downloadFn: function (res) {},

    closeFn: function () {
      this.excellenShow = 0;
      this.selListFn(this.currentPage);
    },

    // 查询
    selListFn: function (page) {
      var obj = {
        page: page || 1,
        size: this.pageSize || 0,
        sfjs: "0",
        isFilterNotPay: 1, // 过滤未支付的订单
      };

      // 是否快速下单
      if (this.isFastType !== "") {
        obj.isFast = this.isFastType;
      }

      if (this.searchType >= 0) {
        obj.status = this.searchType;
      }

      if (this.brandId > 0) {
        obj.brandId = this.brandId;
      }

      if (this.typeId > 0) {
        obj.typeId = this.typeId;
      }

      if (this.searchVle) {
        obj.orderId = this.searchVle;
      }
      if (this.idVle !== "") {
        obj.id = this.idVle;
      }
      if (this.nameVle) {
        obj.nickName = this.nameVle;
      }
      if (this.notesVle) {
        obj.bz = this.notesVle;
      }

      if (this.brandNameVle) {
        obj.brandName = this.brandNameVle;
      }
      if (this.typeNameVle) {
        obj.typeName = this.typeNameVle;
      }

      if (this.logisticsVle) {
        obj.logistics = this.logisticsVle;
      }

      if (this.logisticsVle2) {
        obj.hxinfo = this.logisticsVle2;
      }

      if (this.priceType) {
        obj.jbsx = this.priceType;
      }

      // 获取时间
      if (this.timeVle.length) {
        let sTime = returnTime(new Date(this.timeVle[0]));
        let endTime = returnTime(new Date(this.timeVle[1]));
        obj.begintime = sTime + " 00:00:00";
        obj.endtime = endTime + " 23:59:59";
      }

      this.$https(this.$api.api.selOrder, obj, "POST").then((res) => {
        let data = res.data.data;
        if (res.data.code == 200 && data) {
          data.forEach((v, i) => {
            v.time = returnTime(v.createTime, "-", "s");
            v.images = isJSON(v.images) ? JSON.parse(v.images) : "";
            v.address = isJSON(v.address) ? JSON.parse(v.address) : "";
            v.address2 = isJSON(v.address2) ? JSON.parse(v.address2) : "";
            v.logistics = isJSON(v.logistics) ? JSON.parse(v.logistics) : "";
            v.hxinfo = isJSON(v.hxinfo) ? JSON.parse(v.hxinfo) : "";
            v.jbsx = isJSON(v.jbsx) ? JSON.parse(v.jbsx) : "";
            v.jbService = isJSON(v.jbService) ? JSON.parse(v.jbService) : null;
          });

          this.tableData = data;
          this.tableTotal = res.data.size;
        } else {
          this.tableData = [];
          this.tableTotal = 0;
        }
      });
    },

    // 导出
    excelFn() {
      var obj = {
        page: 1,
        size: 100000,
        sfjs: "0",
      };

      if (this.isFastType !== "") {
        obj.isFast = this.isFastType;
      }

      if (this.searchType >= 0) {
        obj.status = this.searchType;
      }

      if (this.brandId > 0) {
        obj.brandId = this.brandId;
      }

      if (this.typeId > 0) {
        obj.typeId = this.typeId;
      }

      if (this.searchVle) {
        obj.orderId = this.searchVle;
      }
      if (this.idVle !== "") {
        obj.id = this.idVle;
      }

      if (this.nameVle) {
        obj.nickName = this.nameVle;
      }
      if (this.notesVle) {
        obj.bz = this.notesVle;
      }

      if (this.brandNameVle) {
        obj.brandName = this.brandNameVle;
      }
      if (this.typeNameVle) {
        obj.typeName = this.typeNameVle;
      }

      if (this.logisticsVle) {
        obj.logistics = this.logisticsVle;
      }

      if (this.logisticsVle2) {
        obj.hxinfo = this.logisticsVle2;
      }

      if (this.priceType) {
        obj.jbsx = this.priceType;
      }

      // 获取时间
      if (this.timeVle.length) {
        let sTime = returnTime(new Date(this.timeVle[0]));
        let endTime = returnTime(new Date(this.timeVle[1]));
        obj.begintime = sTime + " 00:00:00";
        obj.endtime = endTime + " 23:59:59";
      }
      this.$message("正在导出");
      this.$https(this.$api.api.excelOrder, obj, "POST").then((res) => {
        if (res.data.data) {
          window.location.href = res.data.data;
        }
      });
    },

    // 返回
    returnFn(res) {
      this.selListFn(this.currentPage);
      this.isPage = "index";
      this.historyArr.pop();
    },

    // 分页
    changePage: function (res) {
      this.selListFn(res);
    },

    handlePageSizeChange() {
      this.selListFn(1);
    },

    // 删除
    delFn: delTips(function (list) {
      // var list = this.tableData[index];

      this.$https(
        this.$api.api.delOrder,
        {
          // mubanId: this.$api.mubanId,
          id: list.id,
        },
        "GET"
      ).then((res) => {
        if (res.data.code == 200) {
          this.selListFn(this.currentPage);
          this.$message.success("操作成功");
        } else {
          this.$message.error(res.data.msg);
        }
      });
    }),

    onDrawThreeParts(data, callback) {
      const width = 40;      // 打印纸宽度
      const height = 30;     // 打印纸高度
      const partHeight = height / 3; // 每部分高度

      this.api.startPrintJob({
        width,
        height,
        orientation: this.currOrientation,
        jobName: this.getJobName(),
        printer: this.currPrinter,
        action: this.getJobAction(),
        callback: (success) => {
          if (!success) return;

          // 第一部分：竖排"香味研究所。"
          this.api.drawText({
            text: '香味研究所。',
            x: 0,
            y: 0,
            width: width,
            height: partHeight,
            fontHeight: 6, // 字号可根据实际效果调整
            orientation: 90, // 竖排
            horizontalAlignment: 1, // 居中
            verticalAlignment: 1,   // 居中
            autoReturn: 0,
          });

          // 第二部分：横排"撕毁无效"
          this.api.drawText({
            text: '撕毁无效',
            x: 0,
            y: partHeight,
            width: width,
            height: partHeight,
            fontHeight: 6,
            orientation: 0, // 横排
            horizontalAlignment: 1,
            verticalAlignment: 1,
            autoReturn: 0,
          });

          // 第三部分：二维码
          const qrcodeSize = partHeight * 0.8; // 二维码大小略小于分区高度
          this.api.draw2DQRCode({
            text: data.authenticate,
            x: (width - qrcodeSize) / 2,
            y: partHeight * 2 + (partHeight - qrcodeSize) / 2,
            width: qrcodeSize,
            height: qrcodeSize
          });

          // 提交打印任务
          this.api.commitJob((res) => {
            this.previewJobs(res);
            callback && callback(true);
          });
        },
      });
    },

    getAreaString(address) {
      if (address.areaStr) {
        return address.areaStr;
      }
      return address.area ? address.area.join('') : '';
    },

    // 回滚状态
    canRollbackVerificationOrderStatus,
    rollbackStatus(row) {
      const prevStatus = resolvePreviousVerificationOrderStatus(row.status);
      if (prevStatus == null) {
        this.$message.error("当前状态无法回滚");
        return;
      }
      this.$confirm("确定要将订单状态回滚到上一步吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const obj = {
            id: row.id,
            status: prevStatus,
          };
          return this.updateOrderFn(obj);
        })
        .then((res) => {
          if (res && res.data && res.data.code == 200) {
            this.$message.success("回滚成功");
          } else if (res && res.data && res.data.msg) {
            this.$message.error(res.data.msg);
          } else if (res && res.data && res.data.code != 200) {
            this.$message.error("回滚失败");
          }
        })
        .catch((err) => {
          if (err === "cancel" || err === "close") {
            return;
          }
          this.$message.error("回滚失败");
        });
    },

    // 关闭打印状态对话框
    handleClosePrintDialog() {
      this.printDialogVisible = false;
      this.printResultMessage = null;
    },

    // 普通打印方法
    normalPrint(row) {
      this.printQrFreshReport = false;
      this.printIndex = 0;
      this.printStart(row);
    },

    /** 全新报告打印：逻辑同 normalPrint，标签六位与二维码链接按 id */
    freshReportPrint(row) {
      this.printQrFreshReport = true;
      this.printIndex = 0;
      this.printStart(row);
    },

    // 开始打印
    printStart(row) {
      this.totalNum = 1; // 单张打印
      this.printJson.Printer.printSpeed = this.printSpeed;
      this.printJson.Printer.printDarkness = this.darkness;

      if (this.printError) {
        console.log(this.printNum);
      }

      // 保存当前打印的行数据
      this.currentPrintRow = row;

      // 初始化WebSocket连接
      if (!this.printSocket || this.printSocket.readyState !== WebSocket.OPEN) {
        this.initPrintSocket();
      } else {
        this.printSocket.send('ZM_GetPrinterStatus_USB|500');
      }
    },

    // 初始化打印WebSocket
    initPrintSocket() {
      this.printSocket = new WebSocket("ws://127.0.0.1:1808");

      this.printSocket.onopen = () => {
        console.log('zm printer is connected');
        this.printSocket.send('ZM_GetPrinterStatus_USB|500');
      };

      this.printSocket.onmessage = (event) => {
        console.log(event.data);
        this.printMessage = event.data;

        // 判断打印机状态
        if (this.printMessage.indexOf('PrinterStatus_USB:') === 0) {
          let status = parseInt(this.printMessage.replace("PrinterStatus_USB:", ""));
          if (status !== 0) {
            // 如果查询状态返回的不是0，获取故障原因
            this.printResultMessage = jsonOperator.getStatusMessage(status);
            this.printDialogVisible = true;
            if (!this.printError && (this.printNum !== 0 || this.printNum > this.totalNum)) {
              this.printError = true;
              this.printNum--;
            }
          } else {
            this.printError = false;
            if (this.printNum < this.totalNum) {
              this.printJson.Operate = 'print';

              // 二维码内容 var8：H5 报告页链接（仅 id，小程序按 reportIssuedAt 自动选模板）
              const row = this.currentPrintRow;
              const idStr = row != null && row.id != null ? String(row.id) : "";
              const orderIdStr =
                row != null && row.orderId != null ? String(row.orderId) : "";
              const printData = {
                var1: "香味研究所",
                var2: logoBase64,
                var3: "撕",
                var4: "毁",
                var5: "无",
                var6: "效",
                var7: this.printQrFreshReport
                  ? idStr.slice(-6)
                  : orderIdStr.slice(-6),
                var8: `https://hzshixiang.site/report/prod?id=${row.id}`
              };

              this.printJson.LabelObjectList = jsonOperator.getLabelObjectListByQRCodev2(printData);
              this.printSocket.send(JSON.stringify(this.printJson, null, 2));
              this.printNum++;
            } else {
              this.printResultMessage = '打印结束,共打印' + this.printNum + '张';
              this.printDialogVisible = true;
              this.printNum = 0;
              this.totalNum = 0;
              this.currentPrintRow = null; // 清空当前打印行数据
              this.printQrFreshReport = false;
            }
          }
        }

        if (this.printMessage.indexOf('打印完成') === 0) {
          setTimeout(() => {
            this.printSocket.send('ZM_GetPrinterStatus_USB|500');
            this.printResultMessage = '打印第' + this.printNum + '张完成';
            this.printDialogVisible = true;
          }, 1300);
        }
      };

      this.printSocket.onerror = (error) => {
        console.error('WebSocket连接错误:', error);
        this.printResultMessage = '打印机连接失败，请检查打印服务是否启动';
        this.printDialogVisible = true;
        this.printQrFreshReport = false;
      };
    },
  },
};
</script>

<style lang="less" scoped>
#box {
  width: 100%;

  .historyTag {
    width: 100%;
    height: 50px;
    position: fixed;
    top: 60px;
    z-index: 1000;
    background: #fff;
  }

  .main-with-history {
    padding-top: 50px;
  }

  .topFilter {
    width: 100%;
    background: #fff;
    padding-bottom: 12px;
  }

  .filterBar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px 12px;
  }

  .filterItem {
    flex: 0 0 auto;

    ::v-deep .el-input,
    ::v-deep .el-select {
      width: 160px;
    }

    &--date {
      ::v-deep .el-date-editor {
        width: 240px;
      }
    }
  }

  .filterActions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 0 0 auto;
  }

  .orderMain {
    width: 100%;
    background: #fff;
  }

  .body {
    margin-top: 10px;
  }
}

// 顶部头部
.top_right {
  display: flex;
}

// 顶部头部

// 图片
.imgBox {
  width: 100%;
  display: flex;

  .imgLi {
    width: 80px;
    height: 80px;
    position: relative;
    margin-right: 10px;

    img {
      width: 80px;
      height: 80px;
    }

    .text {
      width: 100%;
      height: 20px;
      background: rgba(000, 000, 000, 0.7);
      color: #fff;
      position: absolute;
      bottom: 0px;
      left: 0px;
      font-size: 12px;
    }
  }
}

// 图片

// 设置为优质卖家
.excellent_box {
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  background: rgba(000, 000, 000, 0.5);

  .excellent_main {
    width: 250px;
    height: 250px;
    margin: auto;
    background: #fff;
    transform: translate(-50%, -50%);
    position: fixed;
    left: 50%;
    top: 50%;
    border-radius: 5px;
    overflow: hidden;

    .excellent_top {
      width: 96%;
      height: 40px;
      background: #eee;
      line-height: 40px;
      padding: 5px 2%;
      font-size: 15px;

      i {
        float: right;
        margin-top: 10px;
        font-size: 20px;
        cursor: pointer;
      }
    }

    .excellent_content {
      width: 100%;
      margin-top: 10px;

      .excellent_li {
        margin-top: 25px;

        .el-select {
          width: 100%;
        }

        span {
          width: 120px;
          display: inline-block;
          flex-shrink: 0;
          text-align: right;
        }
      }

      .excellent_btn {
        justify-content: space-between;
        margin: 25px 15px 0px 0px;
        padding: 0px 20px;
        box-sizing: border-box;
      }
    }
  }
}

//商品
.goodsLi {
  width: 100%;
  display: flex;
  font-size: 12px;
  margin-top: 10px;

  .goodsLi_left {
    width: 60px;
    height: 110rpx;
    flex-shrink: 0;

    img {
      width: 60px;
      height: 110rpx;
    }
  }

  .goodsLi_right {
    width: 100%;
    text-align: left;
    margin-left: 10px;
  }
}

.userBox {
  width: 100%;

  img {
    width: 35px;
    height: 35px;
    box-sizing: border-box;
    border-radius: 50px;
  }
}

//商品

// 物流
.logistics_box {
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  background: rgba(000, 000, 000, 0.5);

  .excellent_main {
    width: 450px;
    height: 250px;
    margin: auto;
    background: #fff;
    transform: translate(-50%, -50%);
    position: fixed;
    left: 50%;
    top: 50%;
    border-radius: 5px;
    overflow: hidden;

    .excellent_top {
      width: 96%;
      height: 40px;
      background: #eee;
      line-height: 40px;
      padding: 5px 2%;
      font-size: 15px;

      i {
        float: right;
        margin-top: 10px;
        font-size: 20px;
        cursor: pointer;
      }
    }

    .excellent_content {
      width: 100%;
      margin-top: 10px;

      .excellent_li {
        margin-top: 25px;

        .el-select {
          width: 100%;
        }

        span {
          width: 120px;
          display: inline-block;
          flex-shrink: 0;
          text-align: right;
        }
      }

      .excellent_btn {
        justify-content: flex-end;
        margin: 25px 15px 0px 0px;
      }
    }
  }
}

// 物流

//弹框数据

.popupMain {
  width: 100%;
  padding: 5px 10px;
  box-sizing: border-box;
  overflow-y: scroll;
  max-height: 80vh;

  .popupLi {
    width: 100%;
    height: auto;
    margin-top: 10px;
    display: flex;
    // padding: 10px;
    // box-sizing: border-box;
    // border: 1px solid #eee;

    .popupLi_title {
      width: 80px;
      flex-shrink: 0;
      line-height: 30px;
      margin-right: 10px;
    }

    .popupLi_content {
      width: 100%;
      text-align: center;

      .imgLi {
        margin-right: 10px;
      }

      .imgLi_text {
        margin-top: 5px;
        color: #555;
      }
    }

    &.popupLi--stacked {
      flex-direction: column;
      align-items: stretch;
    }

    &.popupLi--stacked .popupLi_title {
      width: 100%;
      margin-right: 0;
      margin-bottom: 8px;
      line-height: 1.4;
    }

    &.popupLi--stacked .popupLi_content--full {
      width: 100%;
      text-align: left;
    }
  }
}

.popupBtn {
  justify-content: flex-end;
  margin: 10px auto auto auto;

  .popupBtnLi {
    cursor: pointer;
    margin-right: 6px;
  }
}

// 弹框数据

// 报告
.reportBox {
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: -910000px;
  left: 0;
  z-index: 1000000;
  transform: scale(1);
  font-family: "微软雅黑";

  .captureBox {
    width: 1414px;
    height: 2000px;
    position: relative;
    overflow: hidden;

    .watermark {
      width: 1414px;
      height: 2000px;
      // 水印
      position: absolute;
      z-index: 100;
      top: 0;
      left: 0;

      .watermarkBg {
        width: 1414px;
        height: 2000px;
      }

      .watermarkLi {
        position: absolute;
        font-size: 35px;
        color: rgba(0, 0, 0, 0.2);
        transform: rotateZ(-45deg);
        white-space: nowrap;
      }
    }

    .captureBg {
      width: 1414px;
      height: 2000px;
      position: absolute;
      z-index: 1;
      left: 0;
      top: 0;
    }

    .captureMain {
      width: 1414px;
      height: 2000px;
      position: absolute;
      z-index: 2;
      left: 0;
      top: 0;
      padding: 246px 55px 55px 55px;

      .captureTop {
        width: 100%;
        height: 420px;
        font-size: 40px;
        font-weight: bold;
        position: relative;

        .time {
          height: 50px;
          position: absolute;
          left: 148px;
          top: 192px;
          color: #000;
        }

        .result {
          height: 50px;
          position: absolute;
          left: 155px;
          top: 105px;
        }

        .code {
          height: 50px;
          position: absolute;
          left: 230px;
          top: 319px;
          color: #000;
        }

        // 状态
        // .captureStatus {
        //   width: 210px;
        //   height: 210px;
        //   background: #fff;
        //   border-radius: 100%;
        //   background: rgba(21, 148, 26, 1);
        //   justify-content: center;
        //   font-size: 180px;
        //   color: #fff;
        //   position: absolute;
        //   right: 280px;
        //   top: 230px;

        //   i {
        //     font-weight: bold !important;
        //   }

        // }
      }

      // 图标状态
      .captureStatus {
        width: 260px;
        height: 348px;
        position: absolute;
        right: 250px;
        top: 160px;

        .identifyImg {
          width: 260px;
          height: 348px;
        }
      }
      // 图标状态

      // 商品信息
      .captureGoods {
        width: 100%;
        box-sizing: border-box;

        .captureGoods_li {
          width: 420px;
          height: 240px;
        }

        // 商品
        .goodsMain {
          width: 616px;
          height: 315px;
          box-sizing: border-box;
          padding-left: 3px;
          box-sizing: border-box;
          position: relative;

          .goodsLi {
            width: 99%;
            height: 36px;
            line-height: 18px;
            font-size: 23px;
            font-weight: bold;
            position: absolute;
            left: 23px;
            color: #000;
            display: flex;
            align-items: center;
            gap: 10px;

            .goodsLi_left {
              width: 200px;
              text-align: right;
              padding-right: 10px;
            }

            .goodsLi_right {
              flex: 1;
              text-align: left;
            }
          }

          .goodsLi:nth-child(1) {
            top: 110px;
          }

          .goodsLi:nth-child(2) {
            top: 192px;
          }

          .goodsLi:nth-child(3) {
            top: 242px;

            .goodsLi_num {
              width: 50%;
              box-sizing: border-box;
              display: flex;
              align-items: center;
              white-space: nowrap;
              margin-right: 10px;
              color: #000;
            }

            .goodsLi_num:nth-child(1) {
              padding-left: 70px;
              padding-top: 1px;
            }

            .goodsLi_num:nth-child(2) {
              padding-left: 18px;
            }
          }
        }

        // 实物
        .realMain {
          width: 690px;
          display: flex;
          padding-top: 54px;
          margin-left: 20px;
          box-sizing: border-box;

          .realLi_img {
            width: 150px;
            height: 198px;
            margin-left: 9px;

            img {
              width: 150px;
              height: 198px;
            }
          }

          .realImg_li:nth-child(4) {
            margin-right: 0;
          }

          .noRealTxt {
            font-size: 50px;
            font-weight: bold;
            padding-left: 25px;
            box-sizing: border-box;
            letter-spacing: 2px;
            box-sizing: border-box;
          }
        }
      }

      // 图谱
      .chartMain {
        display: flex;
        padding-top: 50px;
        box-sizing: border-box;
        box-sizing: border-box;

        .chartMain_li {
          width: 614px;
          height: 372px;

          .chartMain_li_img {
            width: 596px;
            height: 150px;
            display: block;
            margin-top: 15px;
          }

          .chartMain_li_img:nth-child(1) {
          }
        }

        .chartMain_li:nth-child(1) {
          padding-left: 20px;
          margin-top: 40px;
          box-sizing: border-box;
        }

        .chartMainEnd {
          margin-left: 16px;
          margin-top: 27px;

          .chartMain_li_img {
            width: 655px;
          }

          .chartMain_overlap {
            width: 655px;
            height: 150px;
            display: block;
            margin-top: 8px;
            position: relative;

            .overlap_img {
              width: 655px;
              height: 150px;
              position: absolute;
              top: 0;
              left: 0;
            }

            .overlap_img:nth-child(1) {
              z-index: 2;
            }

            .overlap_img:nth-child(2) {
              z-index: 1;
              top: 20px;
            }
          }

          .chartMain_text {
            width: 455px;
            padding: 5px;
            box-sizing: border-box;
            font-size: 21px;
            line-height: 32px;
            font-weight: bold;
            margin-top: 10px;

            .chartMainEnd_color {
            }
          }
        }
      }
    }
  }

  .captureBtn {
    position: relative;
    z-index: 100000000;
  }
}
// 报告

// 备注
.textareaFrame {
  width: 100vw;
  height: 100vh;
  background: rgba(000, 000, 000, 0.5);
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: 10000;

  .textareaMain {
    width: 600px;
    height: 570px;
    transform: translate(-50%, -50%);
    background-color: #fff;
    position: fixed;
    left: 50%;
    top: 50%;
    border-radius: 14px;
    z-index: 1000002;

    .title {
      padding: 20px 20px 10px 20px;
      box-sizing: border-box;
      font-size: 28px;
      font-weight: bold;
      text-align: center;
    }

    .text {
      font-size: 26px;
      color: #888;
      text-align: center;
    }

    textarea {
      width: 94%;
      height: 400px;
      border: 2px solid #ccc;
      padding: 20px;
      box-sizing: border-box;
      margin: 20px auto;
      border-radius: 15px;
      display: block;
    }

    .textareaBtnBox {
      width: 100%;
      height: 60px;
      border-top: 2px solid #ccc;
      display: flex;
      align-items: center;

      .textareaBtnLi {
        width: 50%;
        line-height: 60px;
        text-align: center;
        font-size: 20px;
      }

      .textareaBtnLi:nth-child(2) {
        border-left: 2px solid #ccc;
      }
    }
  }
}

/* 鉴别图谱：上传 / TXT 生成 */
.spectrum-jbtp-identify-wrap {
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
}
.spectrum-jbtp-upload-drag {
  width: 100%;
  max-width: 560px;
  box-sizing: border-box;
}
.spectrum-jbtp-txt-actions {
  position: relative;
  display: flex;
  align-items: center;
}
.spectrum-jbtp-txt-input-hidden {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  overflow: hidden;
  border: 0;
  padding: 0;
  margin: 0;
}
.spectrum-jbtp-upload-filled {
  padding: 24px 16px;
  box-sizing: border-box;
}
.spectrum-jbtp-upload-filled .el-icon-picture-outline {
  font-size: 48px;
  color: #67c23a;
  margin-bottom: 8px;
}
.spectrum-jbtp-current-preview {
  width: 100%;
  max-width: 560px;
  margin-top: 4px;
}
.spectrum-jbtp-preview-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 6px;
  line-height: 1.4;
}
.spectrum-jbtp-preview-box {
  width: 100%;
  max-width: 560px;
  min-height: 120px;
  max-height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fafafa;
  box-sizing: border-box;
  padding: 8px;
  overflow: auto;
}
.spectrum-jbtp-preview-img {
  display: block;
  max-width: 100%;
  max-height: 260px;
  width: auto;
  height: auto;
  object-fit: contain;
}
.identify-preview-img-wrap {
  width: 100%;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  max-height: 360px;
  overflow: auto;
  padding: 8px 0;
  box-sizing: border-box;
  background: #fafafa;
  border-radius: 6px;
  border: 1px solid #ebeef5;
}
.identify-preview-img {
  display: block;
  max-width: 100%;
  max-height: 340px;
  width: auto;
  height: auto;
  object-fit: contain;
}
// 备注
</style>
<style>
/* 保持原有的所有样式不变 */
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}
/* ... 其他原有样式保持不变 ... */

/* 只添加新的预览弹窗相关样式 */
.preview-dialog .preview-container {
    max-height: 50vh;
    overflow-y: auto;
    padding: 10px;
}

.preview-dialog .preview-item {
    margin-bottom: 15px;
    text-align: center;
}

.preview-dialog .preview-item img {
    max-width: 100%;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 5px;
}

.preview-dialog .el-dialog__body {
    padding: 10px 20px;
}

.preview-dialog .dialog-footer {
    text-align: right;
    padding: 10px 20px;
}

.preview-dialog .el-button {
    margin-left: 10px;
}

.inspection-verify-dialog.el-dialog {
  margin-top: 10vh !important;
}
.inspection-verify-dialog .el-dialog__body {
  padding: 12px 20px 16px;
  overflow: hidden;
}

.inspection-report-preview-dialog .el-dialog__body {
  padding: 0;
  background: #2c2c2c;
}

.report-preview-dialog-body {
  max-height: calc(92vh - 110px);
  overflow-y: auto;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/pages/goodsOrder/verificationOrder.vue